// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:11.680Z
// Property: The Adirondack (ID: 6767906449165632)
// Collections: 23 amenities, 9 floorplans (live), 51 photos, 75 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165632",
  "property_external_id": "by5d5pc",
  "property_zillow_url": "https://www.zillow.com/apartments/independence-mo/the-adirondack/Ch2dsF/",
  "property_apartments_url": "https://www.apartments.com/the-adirondack-independence-mo/by5d5pc/",
  "property_google_business_url": "https://www.google.com/maps/place/Adirondack/data=!4m2!3m1!1s0x0:0xef524d81f9bd0967?sa=X&ved=2ahUKEwj4me3HgL2SAxW4kyYFHWtJEMgQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/in/ryan-eberly-03135115",
  "property_hubspot_id": "47323490390",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-adirondack",
  "property_name": "The Adirondack",
  "property_website_url": "https://rentnow.adirondackapartmentsindependence.com/",
  "property_domain": null,
  "property_address": "4580 S. Bass Pro Dr.",
  "property_full_address": "4580 S. Bass Pro Dr., Independence, MO, 64055",
  "property_address_1": "4580 S. Bass Pro Dr.",
  "property_address_2": null,
  "property_address_city": "Independence",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64055",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "39th East",
  "property_address_latitude": "39.0397",
  "property_address_longitude": "-94.3723",
  "property_email": "adirondack@caseusa.com",
  "property_phone": "(816) 323-8521",
  "property_call_tracking_phone": "844-730-6351",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Experience modern living at The Adirondack in Independence, Missouri, where spacious one and two-bedroom floor plans meet luxurious amenities. Enjoy a refreshing dip in the pool, workout in the fitness center, or relax in the clubhouse. With pet-friendly features and stylish interiors, your perfect home awaits. Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Adirondack, your premier apartment community nestled in the heart of Independence, Missouri. Choose from our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle, ensuring you find the perfect space to call home. \n\nExperience the ultimate in convenience and leisure with a wealth of exceptional amenities right at your fingertips. Dive into relaxation at our inviting pool, stay active in our state-of-the-art fitness center, or enjoy family time at the playground. Host gatherings at our stylish clubhouse or take advantage of our business center for all your professional needs.\n\nYour comfort and security are our top priorities here at The Adirondack. Our community is gated and features on-site management available 24/7, ensuring peace of mind for all residents. For pet lovers, our pet play area and dog park offer a perfect space for your furry friends to play and socialize.\n\nEach apartment is designed for modern living, featuring luxury finishes like granite countertops, stainless steel appliances, and hardwood floors. Enjoy the coziness of vaulted ceilings, walk-in closets, and a private balcony or patio where you can unwind and take in the views. Convenience is key with in-unit washer/dryer hookups and top-notch appliances including a microwave and dishwasher.\n\nDon’t miss out on the lifestyle you deserve! Find your new home today - browse our availability or schedule a tour to visit our vibrant community. Experience The Adirondack, where comfort meets style in Independence, Missouri!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
    "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "275",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We welcome cats and dogs up to 80 lbs. Maximum of 2 pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs allowed (breed restrictions apply). No weight limit. Maximum 2 pets per unit. One-time pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://adirondackapartmentsindependence.securecafe.com/onlineleasing/the-adirondack/floorplans.aspx",
  "property_resident_portal_url": "https://adirondackapartmentsindependence.securecafe.com/residentservices/the-adirondack/userlogin.aspx",
  "property_apply_now_url": "https://adirondackapartmentsindependence.securecafe.com/onlineleasing/the-adirondack/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-2a10-7459-86b4-962a5c3bec85.webp",
  "property_primary_logo_media": {
    "alt_text": "The Adirondack Apartments logo",
    "public_id": "019cfb49-2a10-7459-86b4-962a5c3bec85",
    "storage_key": "property/6767906449165632/019cfb49-2a10-7459-86b4-962a5c3bec85.webp",
    "width": 300,
    "height": 80
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb4a-62d0-7296-9d97-1cf911c62dbf.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4a-62d0-7296-9d97-1cf911c62dbf",
    "storage_key": "property/6767906449165632/019cfb4a-62d0-7296-9d97-1cf911c62dbf.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb4a-7083-767c-859b-e30d8978707a.webp",
  "property_fav_icon_media": {
    "alt_text": "MA logo.",
    "public_id": "019cfb4a-7083-767c-859b-e30d8978707a",
    "storage_key": "property/6767906449165632/019cfb4a-7083-767c-859b-e30d8978707a.webp",
    "width": 640,
    "height": 640
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-2a10-7459-86b4-962a5c3bec85.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Adirondack Apartments logo",
    "public_id": "019cfb49-2a10-7459-86b4-962a5c3bec85",
    "storage_key": "property/6767906449165632/019cfb49-2a10-7459-86b4-962a5c3bec85.webp",
    "width": 300,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb4a-910a-74d8-8574-4a4cbf27db01.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Adirondack Apartments logo",
    "public_id": "019cfb4a-910a-74d8-8574-4a4cbf27db01",
    "storage_key": "property/6767906449165632/019cfb4a-910a-74d8-8574-4a4cbf27db01.webp",
    "width": 300,
    "height": 80
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#222222",
  "property_secondary_color": "#daba6b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "879 - 1350",
  "property_sqft_min": "879",
  "property_sqft_max": "1350",
  "property_price_range": "1409 - 1869",
  "property_price_min": "1409",
  "property_price_max": "1869",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/AdirondackApts",
  "property_instagram_url": "https://www.instagram.com/p/DT2-i-jgckY/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ83LyL7AdwYcRZwm9-YFNUu8",
  "property_youtube_url": "https://www.youtube.com/watch?v=cM55ysinX6c",
  "property_yelp_url": "https://www.yelp.com/biz/bass-pro-shops-independence-2",
  "property_tiktok_url": "https://www.tiktok.com/@adirondackapartments/video/7389708506414468398",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Adirondack",
  "property_home_romance_title": "Embrace the Joy of Living at Our Charming Community",
  "property_home_amenities_blurb": "At The Adirondack in Independence, Missouri, your ideal home awaits with spacious one and two-bedroom floor plans. Unwind by the pool, stay active in our fitness center, or enjoy family time at the playground. With top-notch features like granite countertops and vaulted ceilings, your comfort is our priority.",
  "property_home_floorplans_blurb": "Welcome to The Adirondack, your haven in Independence, Missouri. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to suit your lifestyle. With spacious layouts and modern amenities, your perfect home is just a click away. Browse our available options and step into your new beginning today!",
  "property_home_gallery_blurb": "At The Adirondack in Independence, Missouri, life is a blend of comfort and style. Choose from spacious one and two-bedroom floor plans featuring modern finishes like granite countertops and stainless steel appliances. Dive into luxury with our resort-style pool, fitness center, and pet-friendly amenities. Picture yourself living here! ",
  "property_home_neighborhood_blurb": "At The Adirondack in Independence, Missouri, experience a vibrant lifestyle surrounded by treasures like the Harry S. Truman Presidential Library and the excitement of GEHA Field at Arrowhead Stadium. With spacious one-bedroom and two-bedroom floor plans, home is just steps away from parks, shopping, and top-notch healthcare facilities. ",
  "property_home_reviews_blurb": "At The Adirondack in Independence, Missouri, our residents rave about the welcoming atmosphere and exceptional service. One new tenant shared, \"Kylie made me feel completely at ease,\" highlighting the dedicated staff committed to enriching your living experience. Ready to join a community that feels like home? ",
  "property_neighborhood_blurb": "At The Adirondack in Independence, Missouri, your vibrant lifestyle flourishes amidst a wealth of local attractions. Discover recreational gems like the Kauffman Stadium, the historic Harry S. Truman Presidential Library, and the scenic beauty of Adair Park, all just moments away. Dive into your new community and uncover everything it has to offer!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Adirondack in Independence, Missouri, luxury meets convenience. Enjoy sun-soaked afternoons by the pool, energize at our fitness center, or unwind in spacious homes featuring hardwood floors and granite countertops. With a dog park, basketball court, and 24-hour access, every day offers a new adventure. Join our vibrant community today!",
  "property_applynow_blurb": "Welcome to The Adirondack, your sanctuary in Independence, Missouri. Choose from spacious one and two-bedroom layouts, each featuring modern amenities like stainless steel appliances, granite countertops, and vaulted ceilings. Enjoy the sunshine by the pool, unleash your energy at the fitness center, or unwind in your pet-friendly haven. Lease online today!",
  "property_contactus_blurb": "Welcome to The Adirondack in Independence, Missouri—where modern comfort meets stylish living. Choose from spacious one and two-bedroom floor plans crafted for your lifestyle. Curious about availability or specifics? Our friendly leasing team is here to help you find your perfect home. Connect with us today for more information!",
  "property_faqs_blurb": "At The Adirondack in Independence, Missouri, we offer a variety of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom apartments. Have questions? Our FAQs page is your go-to resource for everything you need to know about living in our vibrant community—your new home awaits!",
  "property_floorplans_blurb": "At The Adirondack in Independence, Missouri, your ideal living space awaits! With thoughtfully designed one- and two-bedroom floor plans, each residence offers comfort and style. Browse our available apartment homes today and uncover the perfect layout that fits your unique lifestyle and elevates your living experience.",
  "property_gallery_blurb": "At The Adirondack in Independence, Missouri, luxurious living awaits you. Picture your mornings by the pool, evenings in the clubhouse, and weekend barbecues on your patio. With modern amenities like stainless steel appliances, walk-in closets, and a vibrant community, your perfect floor plan is just a click away! ",
  "property_interactivemap_blurb": "Welcome to The Adirondack in Independence, Missouri, where comfort meets style! Choose from spacious one and two-bedroom floor plans, each featuring modern amenities like granite countertops and stainless steel appliances. Enjoy a refreshing dip in the pool, stay active in the fitness center, or unwind in the serene dog park. ",
  "property_pets_blurb": "Embrace life at The Adirondack in Independence, Missouri, where comfort meets companionship. With spacious apartments and a pet-friendly policy, your furry friends (up to 80 lbs) can join you in your new home. Enjoy outdoor adventures and a vibrant community, making every day a delightful experience together.",
  "property_referafriend_blurb": "At The Adirondack in Independence, Missouri, our inviting one and two-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors—refer a friend to join our vibrant community today and experience the warmth and camaraderie that defines our lifestyle!",
  "property_residentaccess_blurb": "Welcome to The Adirondack in Independence, Missouri! Enjoy modern living in our thoughtfully designed one and two-bedroom apartments. With easy access to your resident portal, managing rent payments and scheduling maintenance is just a click away. Dive into community convenience and elevate your lifestyle today!",
  "property_reviews_blurb": "At The Adirondack in Independence, Missouri, resident experiences shine through. Our community is known for its friendly staff, stunning amenities, and beautifully maintained grounds. One happy resident notes, “The staff is exceptional... made the process enjoyable.” See what our residents have to say about living at our community!",
  "property_created_at": "1753982393745",
  "property_scheduletour_blurb": "At The Adirondack in Independence, Missouri, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Experience a vibrant community where every detail resonates with your lifestyle. Don’t just take our word for it—schedule a tour and hear firsthand what our residents love about their home!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Adirondack in Independence, Missouri, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of style and comfort. You’ll love our diverse floor plans tailored to fit your lifestyle. A team member will be in touch soon to assist you!",
  "property_virtualtours_blurb": "Welcome to The Adirondack in Independence, Missouri, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans, perfect for your lifestyle. Embrace modern living and picturesque surroundings. Ready to see more? Take a virtual tour of our vibrant community and discover your new home today!",
  "property_copyright": "2025 All Rights Reserved. The Adirondack",
  "property_seo_title_home": "The Adirondack |  Apartments in Independence, Missouri",
  "property_seo_description_home": "Experience exceptional living at The Adirondack in Independence, MO. From stunning floor plans to top-tier amenities, your perfect home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Independence, Missouri Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Adirondack in Independence, MO. From cozy one-bedrooms to spacious two-bedrooms, see all our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Independence, Missouri Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched living at The Adirondack in Independence, MO! Enjoy luxurious amenities like a pool, fitness center, and dog park—your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Independence, Missouri",
  "property_seo_description_gallery": "Experience life at The Adirondack in Independence, MO! Enjoy amenities like a refreshing pool and stylish interiors. Check out our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | The Adirondack Apartments",
  "property_seo_description_virtualtours": "Experience The Adirondack in Independence, MO! Take a virtual tour of our stylish one and two-bedroom apartments designed for modern living. Join us today!",
  "property_seo_title_interactivemap": "Interactive Map | The Adirondack Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at The Adirondack in Independence, MO! Use our interactive map to find one and two-bedroom apartments with amazing amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Independence, Missouri",
  "property_seo_description_neighborhood": "Discover the charm of Independence, MO at The Adirondack! Enjoy cozy one and two-bedroom apartments near local favorites and attractions!",
  "property_seo_title_contact": "Contact Us | The Adirondack",
  "property_seo_description_contact": "Find your perfect home at The Adirondack in Independence, MO! View spacious one and two-bedroom floor plans. Questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Independence, Missouri",
  "property_seo_description_faqs": "Uncover the answers you seek about The Adirondack in Independence, MO. Our FAQs page provides insights into amenities, floor plans, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Independence, Missouri",
  "property_seo_description_reviews": "Discover life at The Adirondack in Independence, MO, with residents sharing their experiences in our vibrant community and cozy amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Independence, Missouri",
  "property_seo_description_applynow": "Experience upscale living at The Adirondack in Independence, MO. Enjoy luxurious amenities, spacious floor plans, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Adirondack",
  "property_seo_description_residentaccess": "Log in to The Adirondack resident portal for easy rent payments, hassle-free maintenance requests, and all your community needs in Independence, MO!",
  "property_seo_title_referafriend": "Refer A Friend | The Adirondack",
  "property_seo_description_referafriend": "Invite your friends to The Adirondack! Great friends make great neighbors. Share the joys of community living in Independence, MO. Refer today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Adirondack",
  "property_seo_description_scheduletour": "Experience The Adirondack in Independence, MO! Schedule a tour today to see stylish living spaces and fantastic amenities that elevate apartment life.",
  "property_seo_title_privacy": "Privacy Policy | The Adirondack",
  "property_seo_description_privacy": "Your privacy matters! Learn how The Adirondack in Independence, MO protects your information. Trust us for a secure living experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Adirondack",
  "property_seo_description_accessibility": "Embrace inclusivity at The Adirondack in Independence, MO. Our accessibility commitment ensures everyone feels at home. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | The Adirondack",
  "property_seo_description_sitemap": "Navigate your way to The Adirondack in Independence, MO! Uncover all our community features and amenities through our easy-to-use sitemap today.",
  "property_seo_title_thankyou": "Thank You | The Adirondack",
  "property_seo_description_thankyou": "Thank you for reaching out to The Adirondack in Independence, MO! Our team will connect soon—excited to help you find your perfect new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Independence, Missouri",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865895664",
  "amenities": [
    {
      "id": "ec_663bbbcc85bbd43052f01ae4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397239",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24edf34ef29be6c8db1fa658",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397240",
      "title": "Resort-Style Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_172aee9630254bd1bc47d373",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397241",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89a11124ec27fb7ec165d375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397242",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1673870fdf7aaddfa227787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397243",
      "title": "Minutes from Metropolitan Community College - Blue River",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1de9896eb6b2e6510dc9985b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397244",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09998a2d1c589cefff2b7c96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397245",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa8e4ebe07d8fc38978655fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127397246",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_768f140ab6907c8cc19e1a8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398703",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_586127d28a59dd9ddb78b693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398704",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b187ae48b77b4fdab58d5bff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398705",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_caea1d0fefd158dd5140fc7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398706",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d52f5aaedcba9769034d5593",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398707",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15ca7bfcb3bfeb29ed8b1a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398708",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af84095658ef5ef21032918e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398709",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cbd827ec7dd290943b2522e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398710",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17e8af58ecf9134144d86741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398711",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c0143bac42b77bdd4fb4d92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398712",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f4f007c5004b708e7346468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398713",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a8ed4ab0b98ad0d4a88d677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398714",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc9597e307e8be37938d4424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398715",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91d67bd2df8f37a5cd7b2d85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398716",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8827fc9dfac70da3a8607ca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "yardi",
      "external_id": "127398717",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d75ced6d-699a-4d9d-91d0-e8bf4aee9564",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da7-0401-70ae-85f6-51aaf29be8c9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, marble countertop, decorative wall baskets, and a patterned shower curtain.",
        "public_id": "019e1da7-0401-70ae-85f6-51aaf29be8c9",
        "storage_key": "property/6767906449165632/019e1da7-0401-70ae-85f6-51aaf29be8c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom, featuring a spacious vanity and elegant decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, marble countertop, decorative wall baskets, and a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bace15f6-6275-445e-a9f5-acc3ec7ae0d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-8421-719c-a59b-ede31d174a46.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace, TV, sofa, and accent chair.",
        "public_id": "019e1da6-8421-719c-a59b-ede31d174a46",
        "storage_key": "property/6767906449165632/019e1da6-8421-719c-a59b-ede31d174a46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a sleek fireplace, a comfortable sofa, and stylish seating.",
      "link": "",
      "alt_text": "Modern living room with a fireplace, TV, sofa, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8de8ad70-bc25-4152-beaf-f01027a6d6f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-7a72-75ae-8f26-37bdac7c909a.webp",
      "image_media": {
        "alt_text": "Lobby with pool table and Adirondack logo.",
        "public_id": "019e1da6-7a72-75ae-8f26-37bdac7c909a",
        "storage_key": "property/6767906449165632/019e1da6-7a72-75ae-8f26-37bdac7c909a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resident lounge with a pool table and modern decor. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Lobby with pool table and Adirondack logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a3ed4b5-1a43-4774-810c-d362539d5637",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-7796-71ba-a8c1-84b985fc15ca.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, television, sofa, and coffee table.",
        "public_id": "019e1da6-7796-71ba-a8c1-84b985fc15ca",
        "storage_key": "property/6767906449165632/019e1da6-7796-71ba-a8c1-84b985fc15ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern fireplace, mounted television, comfortable sofa, and a stylish coffee table. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, television, sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3cd6d6c-8a6b-4d59-929f-51794ea4b3d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-7818-767a-b1ed-5dac72ce1316.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with a modern fireplace, two green sofas, and a billiards table visible in the background.",
        "public_id": "019e1da6-7818-767a-b1ed-5dac72ce1316",
        "storage_key": "property/6767906449165632/019e1da6-7818-767a-b1ed-5dac72ce1316.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a contemporary fireplace, comfortable seating, and a billiards table for your entertainment.",
      "link": "",
      "alt_text": "Spacious lounge area with a modern fireplace, two green sofas, and a billiards table visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4d204fe-b4d6-4564-ae48-1b4b4a2f9db4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-6ef5-737c-9a8c-98373b02fffb.webp",
      "image_media": {
        "alt_text": "Closet with wire shelving, two wicker baskets, and decorative pillows.",
        "public_id": "019e1da6-6ef5-737c-9a8c-98373b02fffb",
        "storage_key": "property/6767906449165632/019e1da6-6ef5-737c-9a8c-98373b02fffb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet featuring wire shelving for ample storage, complemented by decorative pillows and convenient wicker baskets.",
      "link": "",
      "alt_text": "Closet with wire shelving, two wicker baskets, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1efaec80-5ea1-470b-8582-c057c888d3fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-6b72-708d-9793-0f1c331e646a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop and decorative butterfly wall art.",
        "public_id": "019e1da6-6b72-708d-9793-0f1c331e646a",
        "storage_key": "property/6767906449165632/019e1da6-6b72-708d-9793-0f1c331e646a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy bathroom featuring a vanity with a marble countertop, decorative butterfly wall art, and a view into a hallway with a plant stand.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop and decorative butterfly wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35f6ac53-eddd-4d53-a3e7-4cfc5cad0b03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-69d4-776a-b8f5-d0460de373a5.webp",
      "image_media": {
        "alt_text": "A beautifully staged bedroom with a king-sized bed, nightstands, and a dresser.",
        "public_id": "019e1da6-69d4-776a-b8f5-d0460de373a5",
        "storage_key": "property/6767906449165632/019e1da6-69d4-776a-b8f5-d0460de373a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting bedroom, complete with plush bedding and elegant decor.",
      "link": "",
      "alt_text": "A beautifully staged bedroom with a king-sized bed, nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d49a479-a43f-4afa-9725-2b331fe237ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-52a3-77f6-b0c2-812e3449a707.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and dining area.",
        "public_id": "019e1da6-52a3-77f6-b0c2-812e3449a707",
        "storage_key": "property/6767906449165632/019e1da6-52a3-77f6-b0c2-812e3449a707.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sofa, accent chairs, and a dining nook, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44709f44-09e8-452e-ab4a-390e659a393d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-56d4-768c-b7eb-9e796d52fc9a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with marble countertop, white vanity, and a checkered shower curtain.",
        "public_id": "019e1da6-56d4-768c-b7eb-9e796d52fc9a",
        "storage_key": "property/6767906449165632/019e1da6-56d4-768c-b7eb-9e796d52fc9a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and airy apartment bathroom featuring a clean white tub and shower, stylish checkered curtain, and a spacious vanity with marble countertops.",
      "link": "",
      "alt_text": "Modern bathroom with marble countertop, white vanity, and a checkered shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0335f16b-5a17-464b-a00b-955fe275ed34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-4b21-710f-8b3d-bfa890e60ffb.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs.",
        "public_id": "019e1da6-4b21-710f-8b3d-bfa890e60ffb",
        "storage_key": "property/6767906449165632/019e1da6-4b21-710f-8b3d-bfa890e60ffb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table, comfortable chairs, and decorative accents, perfect for intimate meals or entertaining.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8efddbca-ab33-4c0e-90d8-a59fa7676c16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-468e-71b8-8152-8d97ac72acb4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, marble countertops, and stainless steel appliances, opening to a living area.",
        "public_id": "019e1da6-468e-71b8-8152-8d97ac72acb4",
        "storage_key": "property/6767906449165632/019e1da6-468e-71b8-8152-8d97ac72acb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy apartment kitchen featuring elegant white cabinetry, sleek marble countertops, and a double sink. Enjoy an open-concept living space with ample natural light.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, marble countertops, and stainless steel appliances, opening to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc7de229-4264-49ef-8d6b-0697a1c1dca9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-45ac-757c-a5ba-5160aeff51db.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019e1da6-45ac-757c-a5ba-5160aeff51db",
        "storage_key": "property/6767906449165632/019e1da6-45ac-757c-a5ba-5160aeff51db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this sleek and modern kitchen, featuring pristine white cabinetry, top-of-the-line stainless steel appliances, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0534465d-8a10-43ae-b6f5-0d7d26d36b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-41f2-7791-93e7-edad35d04b51.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a marble island.",
        "public_id": "019e1da6-41f2-7791-93e7-edad35d04b51",
        "storage_key": "property/6767906449165632/019e1da6-41f2-7791-93e7-edad35d04b51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring sleek white cabinetry, a spacious marble-topped island with seating, and stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48c11dfb-a5cc-440e-b651-d2b605e95ffe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-36a7-758c-9345-55e183466aab.webp",
      "image_media": {
        "alt_text": "Chic living room with a white curved sofa, pink accent chair, and a modern desk.",
        "public_id": "019e1da6-36a7-758c-9345-55e183466aab",
        "storage_key": "property/6767906449165632/019e1da6-36a7-758c-9345-55e183466aab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this beautifully appointed apartment featuring a stylish living area with a plush sofa, accent chair, and a dedicated workspace.",
      "link": "",
      "alt_text": "Chic living room with a white curved sofa, pink accent chair, and a modern desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a955c7f9-5041-49e5-a081-d6dc7f27b9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-1b86-757d-8a3a-91f5664ac622.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with marble countertop.",
        "public_id": "019e1da6-1b86-757d-8a3a-91f5664ac622",
        "storage_key": "property/6767906449165632/019e1da6-1b86-757d-8a3a-91f5664ac622.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean and modern design with a white bathtub and tiled shower, a convenient toilet, and a stylish vanity with a marble countertop.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fcbf8fa-0c8d-4789-b4e7-57741582adc1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-1e99-72b0-bd8d-f4108ad1cdab.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dark wood cabinets, white sink, and mirror.",
        "public_id": "019e1da6-1e99-72b0-bd8d-f4108ad1cdab",
        "storage_key": "property/6767906449165632/019e1da6-1e99-72b0-bd8d-f4108ad1cdab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom with a spacious vanity featuring dark wood cabinets, a white sink, and ample counter space.",
      "link": "",
      "alt_text": "Bathroom vanity with dark wood cabinets, white sink, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd1260a5-14bf-4532-8122-0b054205f61a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-2018-703e-a3ef-f41fc87308bc.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a king-size bed, nightstands, and dresser.",
        "public_id": "019e1da6-2018-703e-a3ef-f41fc87308bc",
        "storage_key": "property/6767906449165632/019e1da6-2018-703e-a3ef-f41fc87308bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully staged bedroom, featuring a comfortable king-size bed, elegant nightstands, and a spacious dresser. The room is designed for relaxation and style.",
      "link": "",
      "alt_text": "A staged bedroom with a king-size bed, nightstands, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96841fa5-7c85-40ba-bd47-5f9f1bd989d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-18b5-748d-883e-e306dd5bc148.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019e1da6-18b5-748d-883e-e306dd5bc148",
        "storage_key": "property/6767906449165632/019e1da6-18b5-748d-883e-e306dd5bc148.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, a stainless steel microwave and range, and a double sink with marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b34c559-61f8-4e02-8db6-a659fdc1e22a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da6-12e4-728f-b93d-2742e5fa158e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island.",
        "public_id": "019e1da6-12e4-728f-b93d-2742e5fa158e",
        "storage_key": "property/6767906449165632/019e1da6-12e4-728f-b93d-2742e5fa158e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinetry, a spacious marble island with seating, and stainless steel appliances, perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f296598-7a17-4053-b3d8-16d5bf6e04f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-fc1e-717a-9fba-e5734fd2f6f8.webp",
      "image_media": {
        "alt_text": "Dining area with a marble-top table, four black chairs, and a large potted plant.",
        "public_id": "019e1da5-fc1e-717a-9fba-e5734fd2f6f8",
        "storage_key": "property/6767906449165632/019e1da5-fc1e-717a-9fba-e5734fd2f6f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a meal in this stylish dining area, complete with a modern table, comfortable seating, and a vibrant plant.",
      "link": "",
      "alt_text": "Dining area with a marble-top table, four black chairs, and a large potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13f5a620-4b1e-4014-88fa-62b7f0874a4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-f4fa-77bb-a2ed-021b45967ac8.webp",
      "image_media": {
        "alt_text": "View of the pool and apartment buildings from a balcony.",
        "public_id": "019e1da5-f4fa-77bb-a2ed-021b45967ac8",
        "storage_key": "property/6767906449165632/019e1da5-f4fa-77bb-a2ed-021b45967ac8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the view of the sparkling pool and the beautiful apartment buildings from your private balcony.",
      "link": "",
      "alt_text": "View of the pool and apartment buildings from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dee9173f-c78e-4368-a6f3-2b0977093707",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-f1eb-7230-a471-9dfdbe41873c.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-sized bed, dark wood furniture, and large mirrors.",
        "public_id": "019e1da5-f1eb-7230-a471-9dfdbe41873c",
        "storage_key": "property/6767906449165632/019e1da5-f1eb-7230-a471-9dfdbe41873c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable king-sized bed, elegant dark wood nightstands and dresser, and decorative mirrors that enhance the room's ambiance.",
      "link": "",
      "alt_text": "Primary bedroom with a king-sized bed, dark wood furniture, and large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f502b36-d951-4115-a833-8d7095b6e23a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-f131-745a-86ec-d2d22648c64b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019e1da5-f131-745a-86ec-d2d22648c64b",
        "storage_key": "property/6767906449165632/019e1da5-f131-745a-86ec-d2d22648c64b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, a stainless steel refrigerator and microwave, a sleek stovetop, and elegant marble countertops. Perfect for culinary enthusiasts.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52dd6b40-15f7-42c6-8c7a-30d9ef0a6e67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-f1f5-716a-8e9e-ef109bed2eec.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking a pool and apartment buildings.",
        "public_id": "019e1da5-f1f5-716a-8e9e-ef109bed2eec",
        "storage_key": "property/6767906449165632/019e1da5-f1f5-716a-8e9e-ef109bed2eec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing afternoon on your private balcony, with a view of the sparkling pool and resort-style community amenities.",
      "link": "",
      "alt_text": "View from balcony overlooking a pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_072dcf2c-bc1c-477f-b5ec-7cd17685b2f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-f102-748b-bf8e-efd0f2f1de13.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019e1da5-f102-748b-bf8e-efd0f2f1de13",
        "storage_key": "property/6767906449165632/019e1da5-f102-748b-bf8e-efd0f2f1de13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this stylish apartment kitchen, featuring ample dark wood cabinetry, sleek stainless steel appliances, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0b00eed-0981-4e9b-9eb8-33abb16585eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-e509-757a-a89b-1696e1e64705.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019e1da5-e509-757a-a89b-1696e1e64705",
        "storage_key": "property/6767906449165632/019e1da5-e509-757a-a89b-1696e1e64705.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a king-size bed with plush pillows, a dark wood dresser, and a matching nightstand with a lamp. Large windows allow natural light to fill the space.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2aa1202-c200-4a73-a72b-ff4943479828",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-ce3d-735c-a1f1-a2cc7e319fd9.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sectional sofa, fireplace, and TV.",
        "public_id": "019e1da5-ce3d-735c-a1f1-a2cc7e319fd9",
        "storage_key": "property/6767906449165632/019e1da5-ce3d-735c-a1f1-a2cc7e319fd9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and inviting living room featuring a comfortable sectional sofa, a sleek fireplace with a mounted TV, and large windows.",
      "link": "",
      "alt_text": "Modern living room with a white sectional sofa, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26259cc2-df1c-4928-a254-fa58b9dab138",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-ceec-73d8-a447-fb0e6d138ae5.webp",
      "image_media": {
        "alt_text": "Bright living room with a neutral-toned sofa, decorative pillows, a coffee table, and large windows overlooking apartment buildings.",
        "public_id": "019e1da5-ceec-73d8-a447-fb0e6d138ae5",
        "storage_key": "property/6767906449165632/019e1da5-ceec-73d8-a447-fb0e6d138ae5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this inviting living room, featuring a comfortable sofa, plush decorative pillows, and ample natural light streaming through large windows.",
      "link": "",
      "alt_text": "Bright living room with a neutral-toned sofa, decorative pillows, a coffee table, and large windows overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7f596d8-94e6-4d2f-b961-c47f77003377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-c893-73d1-990e-79d914236b65.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019e1da5-c893-73d1-990e-79d914236b65",
        "storage_key": "property/6767906449165632/019e1da5-c893-73d1-990e-79d914236b65.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with patterned bedding, a wooden dresser, and a nightstand with a lamp and decor.",
      "link": "",
      "alt_text": "Bright bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26d99e83-0d06-4ad2-bd45-dad4c8547dea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-c71d-703d-8ea5-d1c73290f70d.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round black table and four black chairs, decorated with abstract art and a large potted plant.",
        "public_id": "019e1da5-c71d-703d-8ea5-d1c73290f70d",
        "storage_key": "property/6767906449165632/019e1da5-c71d-703d-8ea5-d1c73290f70d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this chic space, featuring a stylish black table set for four, complemented by contemporary abstract art and lush greenery.",
      "link": "",
      "alt_text": "Modern dining area with a round black table and four black chairs, decorated with abstract art and a large potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_daaf6883-390d-451b-a185-a6cefb4cd933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-c824-71c9-a633-a819e9c7f242.webp",
      "image_media": {
        "alt_text": "A light blue sofa, desk with a lamp and artwork, and a round dining table with chairs in a brightly lit apartment.",
        "public_id": "019e1da5-c824-71c9-a633-a819e9c7f242",
        "storage_key": "property/6767906449165632/019e1da5-c824-71c9-a633-a819e9c7f242.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious apartment living and dining area featuring a cozy light blue sofa, a functional desk with decorative items, and a modern dining set with ample natural light.",
      "link": "",
      "alt_text": "A light blue sofa, desk with a lamp and artwork, and a round dining table with chairs in a brightly lit apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11306e94-b984-454f-b709-7da12251ff58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-9ed9-7704-a2e3-8e983d98324c.webp",
      "image_media": {
        "alt_text": "A billiards table and stylish seating area in the community lounge.",
        "public_id": "019e1da5-9ed9-7704-a2e3-8e983d98324c",
        "storage_key": "property/6767906449165632/019e1da5-9ed9-7704-a2e3-8e983d98324c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our vibrant community lounge, featuring a billiards table and comfortable seating.",
      "link": "",
      "alt_text": "A billiards table and stylish seating area in the community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bbeaf3e8-c90c-4a3e-b2d9-ac61df136602",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-9912-7514-ab64-775a9e4dcfda.webp",
      "image_media": {
        "alt_text": "The Adirondack Apartments monument sign with stone pillar and landscaping.",
        "public_id": "019e1da5-9912-7514-ab64-775a9e4dcfda",
        "storage_key": "property/6767906449165632/019e1da5-9912-7514-ab64-775a9e4dcfda.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Welcome to The Adirondack Apartments, a premier residential community. This monument sign greets visitors with modern architecture and thoughtful landscaping.",
      "link": "",
      "alt_text": "The Adirondack Apartments monument sign with stone pillar and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a5f6733-a9bc-4f63-b969-1e8822a3d5d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da4-4bed-774c-92f4-1f7b3098ee7a.webp",
      "image_media": {
        "alt_text": "Living room with a desk, dining area, and sofa.",
        "public_id": "019e1da4-4bed-774c-92f4-1f7b3098ee7a",
        "storage_key": "property/6767906449165632/019e1da4-4bed-774c-92f4-1f7b3098ee7a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern desk, comfortable seating, and a dining nook with large windows for natural light.",
      "link": "",
      "alt_text": "Living room with a desk, dining area, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e516f93-5a48-4190-8c62-381bd4045084",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da4-2722-77cd-9bcb-238b5bde7b61.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with green velvet couches and a stylish chandelier.",
        "public_id": "019e1da4-2722-77cd-9bcb-238b5bde7b61",
        "storage_key": "property/6767906449165632/019e1da4-2722-77cd-9bcb-238b5bde7b61.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed community lounge, featuring comfortable seating, elegant lighting, and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Modern apartment community lounge with green velvet couches and a stylish chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b191f680-1a29-473d-b067-9701abbf1142",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da4-1dac-709d-92d9-01f0b6f9b667.webp",
      "image_media": {
        "alt_text": "Fitness center with free weights, cardio machines, and a weight machine.",
        "public_id": "019e1da4-1dac-709d-92d9-01f0b6f9b667",
        "storage_key": "property/6767906449165632/019e1da4-1dac-709d-92d9-01f0b6f9b667.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio and strength training equipment for resident use.",
      "link": "",
      "alt_text": "Fitness center with free weights, cardio machines, and a weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60b43273-c49b-4728-a1c7-674aeae7c7d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da4-2459-74ab-a138-6f5d623f9133.webp",
      "image_media": {
        "alt_text": "Adirondack property signage, reception desk, and seating area with computers.",
        "public_id": "019e1da4-2459-74ab-a138-6f5d623f9133",
        "storage_key": "property/6767906449165632/019e1da4-2459-74ab-a138-6f5d623f9133.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Adirondack apartments. Our leasing office is ready to assist you with your new home.",
      "link": "",
      "alt_text": "Adirondack property signage, reception desk, and seating area with computers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f62886e-fd3b-41f5-b476-6f459afa9407",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da4-0b9c-7338-890e-923eb77920b2.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, free weights, and yoga balls.",
        "public_id": "019e1da4-0b9c-7338-890e-923eb77920b2",
        "storage_key": "property/6767906449165632/019e1da4-0b9c-7338-890e-923eb77920b2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio equipment, strength training machines, free weights, and more.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, free weights, and yoga balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d914e38-2ee5-45e9-ae24-59ca2c6b6cc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-ef89-7605-ba2b-dd1608cf3256.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge area at an apartment complex.",
        "public_id": "019e1da3-ef89-7605-ba2b-dd1608cf3256",
        "storage_key": "property/6767906449165632/019e1da3-ef89-7605-ba2b-dd1608cf3256.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with comfortable lounge chairs and a tanning ledge.",
      "link": "",
      "alt_text": "Swimming pool and lounge area at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8468b42c-eb02-4b0b-95c7-ec393dcea051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-f503-74fa-96b6-ea1ca299707f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, a multi-gym, and exercise bikes.",
        "public_id": "019e1da3-f503-74fa-96b6-ea1ca299707f",
        "storage_key": "property/6767906449165632/019e1da3-f503-74fa-96b6-ea1ca299707f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, a multi-gym, and exercise bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef48f155-72f5-4792-a295-1f6c4c80bdc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-f196-77bc-baa3-92e910bfcbb2.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e1da3-f196-77bc-baa3-92e910bfcbb2",
        "storage_key": "property/6767906449165632/019e1da3-f196-77bc-baa3-92e910bfcbb2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, perfect for relaxing or swimming laps. Surrounded by comfortable lounge chairs and lush landscaping, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_857978d1-d4c5-47ce-be58-cf4dc5ee0ec4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-ed46-769e-9704-5b3b53d320d1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e1da3-ed46-769e-9704-5b3b53d320d1",
        "storage_key": "property/6767906449165632/019e1da3-ed46-769e-9704-5b3b53d320d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5ade1be-0780-46e2-ae3f-07bf1bb43933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-e980-750b-af44-a32bb71ddfa4.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and covered seating area.",
        "public_id": "019e1da3-e980-750b-af44-a32bb71ddfa4",
        "storage_key": "property/6767906449165632/019e1da3-e980-750b-af44-a32bb71ddfa4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area for ultimate relaxation.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36aa9e2e-4a13-4770-9593-f96fa94a9c40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-b286-77f1-823a-413384aace3d.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic table and built-in grills.",
        "public_id": "019e1da3-b286-77f1-823a-413384aace3d",
        "storage_key": "property/6767906449165632/019e1da3-b286-77f1-823a-413384aace3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor grilling station, complete with multiple grills and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic table and built-in grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff7499a5-a4c2-4db3-8502-1b57102ca921",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-b3dd-709f-96d8-9458b17f729e.webp",
      "image_media": {
        "alt_text": "Exterior view of a building with attached garages.",
        "public_id": "019e1da3-b3dd-709f-96d8-9458b17f729e",
        "storage_key": "property/6767906449165632/019e1da3-b3dd-709f-96d8-9458b17f729e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a building with multiple units and attached garages.",
      "link": "",
      "alt_text": "Exterior view of a building with attached garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c218e2b1-46d4-46a6-94e0-d21412e758e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-a3dc-7185-86a2-e96a7a8488e3.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with stone and green siding, featuring double doors and large windows.",
        "public_id": "019e1da3-a3dc-7185-86a2-e96a7a8488e3",
        "storage_key": "property/6767906449165632/019e1da3-a3dc-7185-86a2-e96a7a8488e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our stunning apartment community, featuring a beautiful exterior with modern architecture and lush landscaping.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with stone and green siding, featuring double doors and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fe8acf3-222f-445d-b648-627cd8666ba5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-a236-7498-9c5d-cfe506802632.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with brick walls, a TV, and grills visible through arches.",
        "public_id": "019e1da3-a236-7498-9c5d-cfe506802632",
        "storage_key": "property/6767906449165632/019e1da3-a236-7498-9c5d-cfe506802632.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor lounge area, complete with a large screen TV and convenient grilling stations.",
      "link": "",
      "alt_text": "Covered outdoor seating area with brick walls, a TV, and grills visible through arches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b380a52c-1554-48d0-9c16-988f7d9ea5cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-a289-7397-aa06-29e2f0bfc5bf.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and swimming pool in the background.",
        "public_id": "019e1da3-a289-7397-aa06-29e2f0bfc5bf",
        "storage_key": "property/6767906449165632/019e1da3-a289-7397-aa06-29e2f0bfc5bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the outdoor fire pit and enjoy a swim in the pool. This communal space offers a perfect spot for residents to unwind and socialize.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and swimming pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_740723db-6a13-47ce-9d72-5a60c2c48843",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-a706-715d-9b41-fd49dfe81741.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and a picnic table.",
        "public_id": "019e1da3-a706-715d-9b41-fd49dfe81741",
        "storage_key": "property/6767906449165632/019e1da3-a706-715d-9b41-fd49dfe81741.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's built-in grills and spacious picnic area, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills and a picnic table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec8e10fa-1232-49de-a3a7-5fdfe34d9f97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-408d-7476-aba9-b7950367effe.webp",
      "image_media": {
        "alt_text": "The Adirondack Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019e1da3-408d-7476-aba9-b7950367effe",
        "storage_key": "property/6767906449165632/019e1da3-408d-7476-aba9-b7950367effe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Adirondack Apartments, a premier residential community featuring modern amenities and beautifully landscaped grounds. This image shows the property's distinctive monument sign at the entrance.",
      "link": "",
      "alt_text": "The Adirondack Apartments monument sign with brick pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_96e8ae6b-7f4f-4461-b5a4-4f9f3b1551bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Main Event Independence",
      "poi_type": "Restaurants",
      "poi_address": "4600 S Cochise Ct, Independence, MO 64055, USA",
      "poi_short_description": "Family entertainment center offers bowling, laser tag, an arcade, and a full bar, plus casual eats.",
      "poi_long_description": "Visitors say this entertainment venue offers a wide variety of family-friendly activities, including bowling, laser tag, and arcade games, with good deals and a fun atmosphere. They also highlight the friendly and helpful staff, and the clean and secure environment.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60c2-74b6-963e-8ed4101b8a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60c2-74b6-963e-8ed4101b8a59",
        "storage_key": "property/6767906449165632/019cfb49-60c2-74b6-963e-8ed4101b8a59.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/missouri/independence",
      "poi_directions_map_url": "https://maps.google.com/?cid=2198162805017869677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-independence",
      "poi_latitude": "39.036406",
      "poi_longitude": "-94.3635965",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-350-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgdYzAwcdwYcRbf2Qv2xxgR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d59bbd9b-343b-414e-b71b-94c95aba64b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "4675 Bass Pro Dr, Independence, MO 64055, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "People say this restaurant serves delicious chicken sandwiches, ribs, and croissants. They also highlight the reasonable prices, great atmosphere, and friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-976e-76ac-a96f-1d8c115ec692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-976e-76ac-a96f-1d8c115ec692",
        "storage_key": "property/6767906449165632/019cfb49-976e-76ac-a96f-1d8c115ec692.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cheddars.com/locations/mo/independence/independence/2095?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:independence-mo-2095_pl:locurl_rd:1081",
      "poi_directions_map_url": "https://maps.google.com/?cid=12117012076092342098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "39.0344726",
      "poi_longitude": "-94.3640794",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-795-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXLRzgwdwYcRUj-a1khGKKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_810c9e38-b1f7-4b2d-9c97-0c2225316c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "4110 S Lee's Summit Rd, Independence, MO 64055, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this restaurant serves delicious chicken dumplings, meatloaf, and pancakes. They also highlight the nostalgic atmosphere, reasonable prices, and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60ff-768f-9ddb-f0b7474d1c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60ff-768f-9ddb-f0b7474d1c0d",
        "storage_key": "property/6767906449165632/019cfb49-60ff-768f-9ddb-f0b7474d1c0d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/mo/independence/179/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=11302538219656632262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.0436938",
      "poi_longitude": "-94.3887656",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-373-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXK3mGUdwYcRxtfomqCu2pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_aca7d6c1-21fa-43e3-bb61-1cf38f1d6478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Summit Grill",
      "poi_type": "Restaurants",
      "poi_address": "4835 NE Lakewood Way, Lee's Summit, MO 64064, USA",
      "poi_short_description": "Stylish neighborhood bar & grill serving steak, seafood, American entrees & cocktails.",
      "poi_long_description": "People say this bar and grill serves delicious chicken fried chicken, pot roast, and seafood macaroni. They also highlight the reasonable prices, great happy hour specials, and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-976e-76ac-a96f-23ccad8b089c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-976e-76ac-a96f-23ccad8b089c",
        "storage_key": "property/6767906449165632/019cfb49-976e-76ac-a96f-23ccad8b089c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://summitgrillkc.com/lees-summit/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15186657018444981727&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summit-grill",
      "poi_latitude": "39.0000022",
      "poi_longitude": "-94.3561158",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-795-1299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b9f-75d5-82dc-bfb3ad496eb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b9f-75d5-82dc-bfb3ad496eb5",
        "storage_key": "property/6767906449165632/019cfb49-7b9f-75d5-82dc-bfb3ad496eb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc055UC0cwYcR3yUbjhjYwdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_6dc30ad0-d94f-4705-aa5a-1290c0e63bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Legend of Asia",
      "poi_type": "Restaurants",
      "poi_address": "1853 SW SW State Rte 7, Blue Springs, MO 64014, USA",
      "poi_short_description": "Sprawling buffet of Chinese dishes plus sushi in a 300-seat dining room.",
      "poi_long_description": "People say this Chinese restaurant offers a wide variety of dishes, including sushi, a salad bar, a dessert bar, and three entree bars. They also highlight the great price, good food, and large selection.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60ce-706e-a977-e16c2805a7ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60ce-706e-a977-e16c2805a7ab",
        "storage_key": "property/6767906449165632/019cfb49-60ce-706e-a977-e16c2805a7ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.legendofasiallc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855944803422138307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legend-of-asia",
      "poi_latitude": "38.9975385",
      "poi_longitude": "-94.2739219",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-220-9833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89psmCwawYcRw29lA2M0SsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_8cb2a592-c318-4332-b25c-b77f95eb457f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Independence Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "18801 East 39th St S, Independence, MO 64057, USA",
      "poi_short_description": "Enclosed mall open since 1974, featuring 100+ well-known stores, plus kiosks & a food court.",
      "poi_long_description": "People say this shopping center offers a variety of stores and is a convenient place to shop, eat, and spend time with friends and family. They also highlight the spacious layout, the nostalgic atmosphere, and the friendly staff.\n\nSome reviews mention there can be a lack of vacancies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-6304-701d-bd11-656853470c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-6304-701d-bd11-656853470c7b",
        "storage_key": "property/6767906449165632/019cfb49-6304-701d-bd11-656853470c7b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://shopindependencecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4311904702555251288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "independence-center",
      "poi_latitude": "39.0453633",
      "poi_longitude": "-94.3580475",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-886-5053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuenuoB0dwYcRWGIkRXv21js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9f463d62-12dc-4ae2-bc79-38da3b60452f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4210 S Lee's Summit Rd, Independence, MO 64055, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers helpful and friendly staff who are always willing to lend a hand, as well as reasonable prices and easy rentals. They also highlight the knowledgeable staff and excellent customer service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60ff-768f-9ddb-f5c6f952b686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60ff-768f-9ddb-f5c6f952b686",
        "storage_key": "property/6767906449165632/019cfb49-60ff-768f-9ddb-f5c6f952b686.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Independence/MO/Independence/64055/3006?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9072178968035324667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.0434695",
      "poi_longitude": "-94.3910737",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-478-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ1pRWWQdwYcR-_KDeLTa5n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b81c6c22-e07b-4998-bc71-1770313d00d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 Little Blue Pkwy, Independence, MO 64057, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of lumber, hardware, and holiday decorations. They also highlight the competitive prices, especially during rebate periods, and the convenient early opening hours.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60f5-71d8-86b0-ab0f18374baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60f5-71d8-86b0-ab0f18374baf",
        "storage_key": "property/6767906449165632/019cfb49-60f5-71d8-86b0-ab0f18374baf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3335&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2231720433688456403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "39.041864",
      "poi_longitude": "-94.337976",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-795-1502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3TfLBewcwYcR0yz7B-mp-B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f30d5f9a-4917-4118-9c8e-3e1bd6608905",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "4201 Sterling Ave, Kansas City, MO 64133, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including electrical tape in various colors, light fixtures, and sink fixtures. They also highlight the reasonable prices, helpful employees, and pleasant shopping experience.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60c5-75ba-b480-114ca06ab1de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60c5-75ba-b480-114ca06ab1de",
        "storage_key": "property/6767906449165632/019cfb49-60c5-75ba-b480-114ca06ab1de.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MO-Kansas-City/2943?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2943-_-na-_-0-_-0&y_source=1_MTE4NDE0Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=32440913174880773&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.046702",
      "poi_longitude": "-94.443406",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-743-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv1pYKB_jwIcRBWL6sdZAcwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_23abf7e9-7fd3-4647-aa93-cd527822eb16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "9400 E State Rte 350, Raytown, MO 64133, USA",
      "poi_short_description": "Market stocked with everyday items as well as unique local brands, plus fresh bakery goods and produce.",
      "poi_long_description": "People say this grocery store offers a wide variety of items, including fresh produce, quality meats, and a delicious bakery. They also highlight the clean and well-organized store layout, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9749-71b9-b40c-da5ec443e668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9749-71b9-b40c-da5ec443e668",
        "storage_key": "property/6767906449165632/019cfb49-9749-71b9-b40c-da5ec443e668.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=141&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1417580871346384270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9936824",
      "poi_longitude": "-94.4695156",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-358-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b7f-778b-977f-1a1127d44097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b7f-778b-977f-1a1127d44097",
        "storage_key": "property/6767906449165632/019cfb49-7b7f-778b-977f-1a1127d44097.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3ti2PnjwIcRjm39tEpCrBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8546d933-2621-4081-92c9-484e582403aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Metropolitan Community College - Blue River",
      "poi_type": "Education",
      "poi_address": "20301 MO-78, Independence, MO 64057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-669d-7255-ab90-f5bfd040e576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-669d-7255-ab90-f5bfd040e576",
        "storage_key": "property/6767906449165632/019cfb49-669d-7255-ab90-f5bfd040e576.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://mcckc.edu/blueriver",
      "poi_directions_map_url": "https://maps.google.com/?cid=2183778788819373588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-community-college---blue-river",
      "poi_latitude": "39.0825164",
      "poi_longitude": "-94.3392775",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ44hNczcDwYcRFI6c_zxXTh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3ab396a3-0c8a-4acf-a73c-1eb5ab5f27b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "GEHA Field at Arrowhead Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Arrowhead Dr, Kansas City, MO 64129, USA",
      "poi_short_description": "Open-air stadium that's home to pro football's Kansas City Chiefs, also hosting big-name music acts.",
      "poi_long_description": "People say this stadium offers a great game day experience with a fantastic atmosphere and a wide variety of food and drink options. They highlight the passionate and welcoming fans, and the easy entry and parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-98ea-72f8-a1f4-1fb2a97fee79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-98ea-72f8-a1f4-1fb2a97fee79",
        "storage_key": "property/6767906449165632/019cfb49-98ea-72f8-a1f4-1fb2a97fee79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chiefs.com/stadium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13604615317193311462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "geha-field-at-arrowhead-stadium",
      "poi_latitude": "39.0489647",
      "poi_longitude": "-94.4840141",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-920-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc6-758c-a5d7-27631abb3f32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc6-758c-a5d7-27631abb3f32",
        "storage_key": "property/6767906449165632/019cfb49-7bc6-758c-a5d7-27631abb3f32.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK5LblKHkwIcR5kQl94xNzbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_840b4d2c-1001-40f3-8a2d-1c4df0eb7429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Kauffman Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Royal Way, Kansas City, MO 64129, USA",
      "poi_short_description": "Pro-baseball complex including the Royals Hall of Fame & a themed kids' play/practice area.",
      "poi_long_description": "People say this stadium offers a variety of food options, including hot dogs and BBQ, and has a fun atmosphere with fireworks and fountains. They highlight the affordable ticket prices and the family-friendly vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-98e4-7025-971b-fca82df056d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-98e4-7025-971b-fca82df056d7",
        "storage_key": "property/6767906449165632/019cfb49-98e4-7025-971b-fca82df056d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/royals/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16543369561678857872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kauffman-stadium",
      "poi_latitude": "39.0514836",
      "poi_longitude": "-94.480493",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-921-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc6-758c-a5d7-27631abb3f32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc6-758c-a5d7-27631abb3f32",
        "storage_key": "property/6767906449165632/019cfb49-7bc6-758c-a5d7-27631abb3f32.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcaDcmaDkwIcRkMbgP_faleU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b267b8e8-4119-44ff-bc4d-9a34a2b2bd34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Cable Dahmer Arena",
      "poi_type": "Entertainment",
      "poi_address": "19100 E Valley View Pkwy, Independence, MO 64055, USA",
      "poi_short_description": "Venue hosting concerts, hockey games, and other events, plus concessions.",
      "poi_long_description": "People say this arena hosts a variety of events, including concerts, hockey games, and graduations. They highlight the fun and exciting atmosphere, and the good views from all seats. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9958-7757-b04b-8ef518ae5143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9958-7757-b04b-8ef518ae5143",
        "storage_key": "property/6767906449165632/019cfb49-9958-7757-b04b-8ef518ae5143.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cabledahmerarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15729911222784680601&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cable-dahmer-arena",
      "poi_latitude": "39.0400091",
      "poi_longitude": "-94.3573681",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-442-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcW9sYQIdwYcRmeKCnureS9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f0fe464f-1188-450f-a32f-b2c9f1a55dda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Harry S. Truman Presidential Library & Museum",
      "poi_type": "Entertainment",
      "poi_address": "New Entrance on East Side of Building, 500 W US Hwy 24, Independence, MO 64050, USA",
      "poi_short_description": "Research library & museum detailing the life & work of the 33rd president & his administration.",
      "poi_long_description": "People say this museum offers informative exhibits, interactive displays, and artifacts that capture the era. They highlight the well-organized layout, the engaging videos, and the thorough coverage of the president's life and presidency, including the Korean War. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-673e-7549-ba9e-cfc33b57e4fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-673e-7549-ba9e-cfc33b57e4fd",
        "storage_key": "property/6767906449165632/019cfb49-673e-7549-ba9e-cfc33b57e4fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.trumanlibrary.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11291584855531978826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-s-truman-presidential-library--museum",
      "poi_latitude": "39.1034674",
      "poi_longitude": "-94.4208008",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-268-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b88-7259-8f7a-5a785a44274e",
        "storage_key": "property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1ZWog39wIcRSgAqyZnEs5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_02bc533d-0ab9-437a-afb1-d77dd88c2c2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "2801 NE McBaine Dr, Lee's Summit, MO 64063, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers fun slides and a variety of activities for kids of all ages.\n\nOther reviews mention the staff can be inattentive and the facilities can be unorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-6703-7759-a0a7-3e4cad9b17b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-6703-7759-a0a7-3e4cad9b17b8",
        "storage_key": "property/6767906449165632/019cfb49-6703-7759-a0a7-3e4cad9b17b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.skyzone.com/leessummit/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7734966539122557549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "38.96353",
      "poi_longitude": "-94.3598142",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-272-4713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJazlmMFkewYcRbcLu8RUfWGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8e3ed314-6f98-4007-8636-e66da5e627e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Independence",
      "poi_type": "Health and Wellness",
      "poi_address": "3850 S Crackerneck Rd, Independence, MO 64055, USA",
      "poi_short_description": "Chain fitness center with a pool, basketball court, and group classes, plus steam and dry saunas.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, including cardio machines, squat racks, dumbbells, benches, cable machines, and regular machines, as well as a basketball court, pool, sauna, steam room, and lap lanes. They also highlight the friendly and helpful staff, particularly mentioning the front desk team who make delicious protein shakes, and the clean facilities.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-68bd-72f3-b927-dd4f044c57a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-68bd-72f3-b927-dd4f044c57a5",
        "storage_key": "property/6767906449165632/019cfb49-68bd-72f3-b927-dd4f044c57a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/independence.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10318381194153217481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---independence",
      "poi_latitude": "39.0499072",
      "poi_longitude": "-94.3742706",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-478-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0e4pphUdwYcRyc2S5gZBMo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d074c76f-96c1-4ace-99d5-44ca20098034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4545 B S Noland Rd, Independence, MO 64055, USA",
      "poi_short_description": "Chain gym with massage chairs and tanning beds, as well as a membership requirement.",
      "poi_long_description": "People say this gym offers tanning beds and booths, and heavy weights. They highlight the judgment-free atmosphere and the well-maintained equipment. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9a27-779b-b585-3c123a4324db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9a27-779b-b585-3c123a4324db",
        "storage_key": "property/6767906449165632/019cfb49-9a27-779b-b585-3c123a4324db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/independence-mo?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15881352799050767295&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.03741290000001",
      "poi_longitude": "-94.4133481",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-478-7095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53BfTYziwIcRv5sTTDrmZdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_54c53655-2d4d-4463-8a0e-653faf19c0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Fieldhouse - Blue Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "425 NE Mock Ave, Blue Springs, MO 64014, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of exercise options, including a waterpark, basketball courts, and a gym with modern equipment.\n\nOther reviews mention the facility can be crowded and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9a5a-738b-a973-204bba1e3350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9a5a-738b-a973-204bba1e3350",
        "storage_key": "property/6767906449165632/019cfb49-9a5a-738b-a973-204bba1e3350.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bluespringsgov.com/2457/Fieldhouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=5513789323055872589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fieldhouse---blue-springs",
      "poi_latitude": "39.02777409999999",
      "poi_longitude": "-94.2586098",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-228-0137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46_5LgAbwYcRTToWDy3qhEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a6c08226-7f17-4ed6-a24c-38347c019f07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Blue Springs Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 US-40, Blue Springs, MO 64015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9a66-731e-a354-96dcb4745678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9a66-731e-a354-96dcb4745678",
        "storage_key": "property/6767906449165632/019cfb49-9a66-731e-a354-96dcb4745678.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://bluespringsanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4261080813897927872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-springs-animal-hospital",
      "poi_latitude": "39.01027020000001",
      "poi_longitude": "-94.2793711",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-229-1544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7zOXMkbwYcRwEyej2xmIjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1b95bf88-5d57-4336-92d1-c1a21b572bbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Independence Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "300 S Noland Rd, Independence, MO 64050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7051-729f-a848-e81996bde669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-7051-729f-a848-e81996bde669",
        "storage_key": "property/6767906449165632/019cfb49-7051-729f-a848-e81996bde669.webp",
        "width": 1144,
        "height": 438
      },
      "poi_business_url": "http://independenceanimalhospital.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3577771510206407800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "independence-animal-hospital",
      "poi_latitude": "39.0894519",
      "poi_longitude": "-94.41388270000002",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-254-4282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm2fYgkH9wIcReKRdkTvMpjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_bf052c89-bbeb-4a38-97d0-00b5fd56d122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3495 NE Ralph Powell Rd, Lee's Summit, MO 64064, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9b16-72ce-8d53-7218d72a2f18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9b16-72ce-8d53-7218d72a2f18",
        "storage_key": "property/6767906449165632/019cfb49-9b16-72ce-8d53-7218d72a2f18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/lees-summit-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12547310043383341568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "38.9751608",
      "poi_longitude": "-94.3578983",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-554-4990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe-XUP2IewYcRACKOhgEAIa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a2ddf8b2-2b76-4e1e-bd4a-3f6e4aec21cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Three Trails Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "600 West 23rd St S, Independence, MO 64055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9bb7-75d9-85ec-f229a9ca6a52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9bb7-75d9-85ec-f229a9ca6a52",
        "storage_key": "property/6767906449165632/019cfb49-9bb7-75d9-85ec-f229a9ca6a52.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://www.threetrailsah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5377072140031629132&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "three-trails-animal-hospital",
      "poi_latitude": "39.07985",
      "poi_longitude": "-94.42355",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-252-5105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8FVMTf9wIcRTBc8Vp8yn0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_51dff5db-b33d-4da0-8382-c3711eefa3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Centerpoint Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19600 East 39th St S, Independence, MO 64057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9bef-73cd-88e6-312978c82c1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9bef-73cd-88e6-312978c82c1b",
        "storage_key": "property/6767906449165632/019cfb49-9bef-73cd-88e6-312978c82c1b.webp",
        "width": 1280,
        "height": 1098
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/centerpoint-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160633253699612694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centerpoint-medical-center",
      "poi_latitude": "39.0494402",
      "poi_longitude": "-94.348743",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-698-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb0-732b-a22b-60edc8ba9a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb0-732b-a22b-60edc8ba9a87",
        "storage_key": "property/6767906449165632/019cfb49-7bb0-732b-a22b-60edc8ba9a87.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu8B7XOEcwYcRFnAtC9CI4po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_e85cc5a6-4317-40f6-8f4a-e5c683612e29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "University Health Lakewood Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7900 Lee's Summit Rd, Kansas City, MO 64139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-6f1f-70ac-b1ed-90f52465d1a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-6f1f-70ac-b1ed-90f52465d1a4",
        "storage_key": "property/6767906449165632/019cfb49-6f1f-70ac-b1ed-90f52465d1a4.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=983355296762136457&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-health-lakewood-medical-center",
      "poi_latitude": "38.9750259",
      "poi_longitude": "-94.3949087",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-404-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb0-732b-a22b-60edc8ba9a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb0-732b-a22b-60edc8ba9a87",
        "storage_key": "property/6767906449165632/019cfb49-7bb0-732b-a22b-60edc8ba9a87.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwIZqh0ewYcRiYeBr26UpQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9f3683c0-0e03-49fa-875b-41c93c76492b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Drumm Farm Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15400 E 34th St S, Independence, MO 64055, USA",
      "poi_short_description": "Challenging but fair layout on preserved farmland, featuring bent grass greens and wide-open fairways.",
      "poi_long_description": "People say this golf course offers a beautiful layout and fun, interesting holes. They also highlight the friendly staff and the availability of electric carts and a driving range.\n\nSome reviews mention the course conditions can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-6f20-77bd-83dd-62b8ef025185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-6f20-77bd-83dd-62b8ef025185",
        "storage_key": "property/6767906449165632/019cfb49-6f20-77bd-83dd-62b8ef025185.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://drummfarmgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5544308847749566332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "drumm-farm-golf-club",
      "poi_latitude": "39.0596656",
      "poi_longitude": "-94.397026",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-350-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb7-71ed-a0fe-7a69b7db33c2",
        "storage_key": "property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3Fn-afiwIcRfA8ro4VX8Uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a6d304b1-43d1-4fb0-8999-2f7353ef70f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Blue Springs Lake Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5400 NE Campground Rd, Lee's Summit, MO 64064, USA",
      "poi_short_description": "Tranquil campground offering shaded sites, plus showers, a playground and beach access.",
      "poi_long_description": "People say this campground offers spacious sites and full hookups. They also highlight the clean facilities, friendly staff, and well-maintained grounds.\n\nOther reviews mention the sites can be unlevel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-6fc7-75be-9888-6919631ddcd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-6fc7-75be-9888-6919631ddcd1",
        "storage_key": "property/6767906449165632/019cfb49-6fc7-75be-9888-6919631ddcd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.makeyourdayhere.com/campgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=13422656624005283223&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-springs-lake-campground",
      "poi_latitude": "39.010128",
      "poi_longitude": "-94.3482957",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-503-4805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7e99-757a-9637-302899319d36",
        "storage_key": "property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9MszzccwYcRl_3gTxXbRro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b44ce58a-8450-4afe-88fb-478e240be042",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Stone Canyon Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22415 East 39th St S, Blue Springs, MO 64015, USA",
      "poi_short_description": "Public golf course with a driving range, chipping area, and putting green.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9dc7-70fc-ba3d-51fa698eb7cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9dc7-70fc-ba3d-51fa698eb7cb",
        "storage_key": "property/6767906449165632/019cfb49-9dc7-70fc-ba3d-51fa698eb7cb.webp",
        "width": 963,
        "height": 609
      },
      "poi_business_url": "http://www.stonecanyongolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7395707524587571612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stone-canyon-golf-club",
      "poi_latitude": "39.0447731",
      "poi_longitude": "-94.3143705",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-228-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb7-71ed-a0fe-7a69b7db33c2",
        "storage_key": "property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-kIhewcwYcRnMm5Oc_UomY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_9db7a19f-6f35-4759-9869-23940b68b337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Burrus Old Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "112 NW Woods Chapel Rd, Blue Springs, MO 64015, USA",
      "poi_short_description": "14-acre hangout with a skate park, walking trail, playground & sports facilities.",
      "poi_long_description": "Visitors say this park offers a great splash pad and playground with a variety of equipment for all ages, and plenty of shade. They also highlight the clean facilities, including restrooms, and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-74d2-7448-bea1-189180a9deff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-74d2-7448-bea1-189180a9deff",
        "storage_key": "property/6767906449165632/019cfb49-74d2-7448-bea1-189180a9deff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bluespringsgov.com/1386/Burrus-Old-Mill-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12868716007812158334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burrus-old-mill-park",
      "poi_latitude": "39.0190849",
      "poi_longitude": "-94.2997936",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-228-0137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7e99-757a-9637-302899319d36",
        "storage_key": "property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD3pJTJEbwYcRftMGGQfdlrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1fcea2e5-95f2-497f-8e93-56262f70daa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "WinterStone Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17101 E Kentucky Rd, Independence, MO 64058, USA",
      "poi_short_description": "Golf course featuring tight fairways and bunkers, plus hilly areas.",
      "poi_long_description": "People say this golf course offers a challenging and scenic layout with rolling hills and elevation changes. They highlight the well-maintained fairways, smooth greens, and fast, true greens. They also like the friendly and helpful staff, and the better-than-average practice facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9e8d-74df-a866-a960c42601d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9e8d-74df-a866-a960c42601d1",
        "storage_key": "property/6767906449165632/019cfb49-9e8d-74df-a866-a960c42601d1.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.winterstonegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013998365048837010&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winterstone-golf-course",
      "poi_latitude": "39.1271667",
      "poi_longitude": "-94.3772735",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-257-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb7-71ed-a0fe-7a69b7db33c2",
        "storage_key": "property/6767906449165632/019cfb49-7bb7-71ed-a0fe-7a69b7db33c2.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJudYlm24CwYcRkhO89T6WtDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ef2f2625-1b1e-4978-9fd3-b40563ab90b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Lee's Summit Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2740 NE Hagan Rd, Lee's Summit, MO 64064, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9f0d-75c1-8eef-e426f6a92113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9f0d-75c1-8eef-e426f6a92113",
        "storage_key": "property/6767906449165632/019cfb49-9f0d-75c1-8eef-e426f6a92113.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofls.net/kclsregional",
      "poi_directions_map_url": "https://maps.google.com/?cid=3047688349481206235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lees-summit-municipal-airport",
      "poi_latitude": "38.9625609",
      "poi_longitude": "-94.3681383",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-969-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ea2-7379-b74f-d6f99c050829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ea2-7379-b74f-d6f99c050829",
        "storage_key": "property/6767906449165632/019cfb49-7ea2-7379-b74f-d6f99c050829.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7Ds3EUewYcR24HsEGiQSyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_bccab904-c3e8-4c11-a718-c7a7b6f52c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Independence, Missouri",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 S Grand Ave, Independence, MO 64050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-9f44-7728-b7f1-2782bf1deb48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-9f44-7728-b7f1-2782bf1deb48",
        "storage_key": "property/6767906449165632/019cfb49-9f44-7728-b7f1-2782bf1deb48.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=IDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=773920873971481675&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "independence-missouri",
      "poi_latitude": "39.0868706",
      "poi_longitude": "-94.4297521",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ee6-71de-9223-034e599f1eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ee6-71de-9223-034e599f1eb3",
        "storage_key": "property/6767906449165632/019cfb49-7ee6-71de-9223-034e599f1eb3.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrW8zNiP9wIcRS3xUOe-EvQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b0c8784d-bd11-4f44-bf87-6c74e8e0f06b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Fike Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "704 SW 10th St, Blue Springs, MO 64015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7759-754b-93aa-519298b6f173.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-7759-754b-93aa-519298b6f173",
        "storage_key": "property/6767906449165632/019cfb49-7759-754b-93aa-519298b6f173.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.fike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7982226501077443580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fike-corporation",
      "poi_latitude": "39.0107639",
      "poi_longitude": "-94.2759816",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-937-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7NUYMobwYcR_CNuCbaQxm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6bc00189-5a68-41a7-989f-46fb944cc8e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Independence Square Association",
      "poi_type": "Major Employers & Offices",
      "poi_address": "106 S Liberty St, Independence, MO 64050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-747d-752a-8694-c01321ee8cdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-747d-752a-8694-c01321ee8cdd",
        "storage_key": "property/6767906449165632/019cfb49-747d-752a-8694-c01321ee8cdd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.indepsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18053709724508723916&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "independence-square-association",
      "poi_latitude": "39.0918818",
      "poi_longitude": "-94.4172858",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-381-7181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPS1Tp2r9wIcRzJpbf1epi_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9f319fd0-10d5-4565-8b0c-d6843ab6dc0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Blue Springs City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "903 W Main St, Blue Springs, MO 64015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-76ee-709f-92b1-5dc14ffb336f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-76ee-709f-92b1-5dc14ffb336f",
        "storage_key": "property/6767906449165632/019cfb49-76ee-709f-92b1-5dc14ffb336f.webp",
        "width": 1280,
        "height": 773
      },
      "poi_business_url": "http://www.bluespringsgov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5541918662586329697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-springs-city-hall",
      "poi_latitude": "39.0187125",
      "poi_longitude": "-94.2759649",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-228-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7eb6-758d-b9f0-428991bd7b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7eb6-758d-b9f0-428991bd7b78",
        "storage_key": "property/6767906449165632/019cfb49-7eb6-758d-b9f0-428991bd7b78.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8x1nLQbwYcRYeqQSanZ6Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_37d688ad-f6eb-4b6b-95d5-f9ae07713913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "IdentGo",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5542 Raytown Rd, Raytown, MO 64133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.identogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17438939680004392164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "identgo",
      "poi_latitude": "39.0220267",
      "poi_longitude": "-94.46771160000002",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcStePwDjwIcR5EQgVj6PA_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_35a65680-6fd8-4501-9ae3-187c8e56c103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "KeyPoint Counseling Services, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Blue Ridge Cutoff Suites 305-311, Raytown, MO 64133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17170667709818584958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "keypoint-counseling-services-llc",
      "poi_latitude": "39.0107095",
      "poi_longitude": "-94.4825109",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-607-1256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQyN_lTlwIcRfr8B2E53Su4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b15008e4-3a14-448a-90a1-20ec1649650b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "William Yates Elementary School",
      "poi_type": "Education",
      "poi_address": "3600 S Davidson Ave, Independence, MO 64055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-477e-700f-955b-61c32ce1b3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-477e-700f-955b-61c32ce1b3ed",
        "storage_key": "property/6767906449165632/019d7913-477e-700f-955b-61c32ce1b3ed.webp",
        "width": 1280,
        "height": 639
      },
      "poi_business_url": "https://wye.bssd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3645339740608760696&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "william-yates-elementary-school",
      "poi_latitude": "39.0528718",
      "poi_longitude": "-94.3763339",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-874-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj-pOWBUdwYcReIuZJC7ZljI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c91bd181-3ebb-424c-9c8b-69e4d148010f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Delta Woods Middle School",
      "poi_type": "Education",
      "poi_address": "4401 NE Lakewood Way, Lee's Summit, MO 64064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-294e-76c3-8c08-2c176b838b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-294e-76c3-8c08-2c176b838b16",
        "storage_key": "property/6767906449165632/019d7913-294e-76c3-8c08-2c176b838b16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dwms.bssd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6698699527730167534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "delta-woods-middle-school",
      "poi_latitude": "38.9919595",
      "poi_longitude": "-94.3553094",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-874-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR2Ld6yocwYcR7v5ur7qP9lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_26f45d92-b4ae-431e-be25-d871cb3def09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Blue Springs High School",
      "poi_type": "Education",
      "poi_address": "2000 NW Ashton Dr, Blue Springs, MO 64015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-29ff-7047-9d9b-83e45c92532f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-29ff-7047-9d9b-83e45c92532f",
        "storage_key": "property/6767906449165632/019d7913-29ff-7047-9d9b-83e45c92532f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bshs.bssd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646148376183981222&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-springs-high-school",
      "poi_latitude": "39.0266778",
      "poi_longitude": "-94.2881512",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-874-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA6-m96QbwYcRpkRUK_IkgK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e25fb8bb-4e5f-49a8-a097-e8a5252c60c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-5c9f-73d3-bc16-2696c492173d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5c9f-73d3-bc16-2696c492173d",
        "storage_key": "property/6767906449165632/019d7913-5c9f-73d3-bc16-2696c492173d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_20241d77-87a8-476b-bf1e-b944c49d244b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Park University in Independence, MO",
      "poi_type": "Education",
      "poi_address": "20101 E Jackson Dr, Independence, MO 64057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-3151-7759-ba48-b1752a58a6f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3151-7759-ba48-b1752a58a6f4",
        "storage_key": "property/6767906449165632/019d7913-3151-7759-ba48-b1752a58a6f4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.park.edu/academics/explore-majors-programs/?location=mo-independence",
      "poi_directions_map_url": "https://maps.google.com/?cid=13536535199795105934&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "park-university-in-independence-mo",
      "poi_latitude": "39.0408886",
      "poi_longitude": "-94.3437134",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-584-6560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bc8-76bc-83c9-a2df8b0e3a55",
        "storage_key": "property/6767906449165632/019cfb49-7bc8-76bc-83c9-a2df8b0e3a55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk73BVrYCwYcRjtBbaQtv27s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ceb258af-1f72-4586-9215-694a989322e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Hereford House - Independence",
      "poi_type": "Restaurants",
      "poi_address": "19721 E Jackson Dr, Independence, MO 64057, USA",
      "poi_short_description": "Casual steakhouse offering prime beef & sides, plus happy hour & Sunday specials.",
      "poi_long_description": "People say this steakhouse offers delicious prime rib, steaks, and other traditional American fare. They also highlight the comfortable, casual dining atmosphere and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-32c5-72f9-b38d-545fd126dafc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-32c5-72f9-b38d-545fd126dafc",
        "storage_key": "property/6767906449165632/019d7913-32c5-72f9-b38d-545fd126dafc.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.herefordhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6912995186189860921&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hereford-house-independence",
      "poi_latitude": "39.04070129999999",
      "poi_longitude": "-94.3478964",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-795-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5Rsv_ocwYcROQDVxn7k718",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d198071b-cc4a-4fba-ae1c-9d3199d1356c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "BD's Mongolian Grill",
      "poi_type": "Restaurants",
      "poi_address": "19750 E Valley View Pkwy, Independence, MO 64057, USA",
      "poi_short_description": "Casual chain offering create-your-own stir-fry bowls, plus appetizers, desserts & cocktails.",
      "poi_long_description": "People say this restaurant offers a wide selection of meats, vegetables, and sauces for creating custom bowls. They also highlight the reasonable prices, fun and lively atmosphere, and friendly staff.\n\nSome reviews mention the sauces can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-3aac-74e8-9dd7-f18b0791e1bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3aac-74e8-9dd7-f18b0791e1bb",
        "storage_key": "property/6767906449165632/019d7913-3aac-74e8-9dd7-f18b0791e1bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bdsgrill.com/mo/independence/bds-mongolian-grill-520.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=18345166845498517789&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bd-s-mongolian-grill",
      "poi_latitude": "39.0391367",
      "poi_longitude": "-94.3478517",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-795-5430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eRXW_ocwYcRHWk2kwwgl_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "custom_ec0ee168-30b0-4bbc-8cb3-78d78ef9742a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "19321 US-40 L, Independence, MO 64055, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "People say this breakfast restaurant serves delicious and fresh food, including omelets, waffles, and seasonal specials. They highlight the friendly and welcoming atmosphere, and the quick and attentive service. They also like the reasonable prices and the cozy, homey feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-4397-72b1-884d-c69fecee2c89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4397-72b1-884d-c69fecee2c89",
        "storage_key": "property/6767906449165632/019d7913-4397-72b1-884d-c69fecee2c89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.firstwatch.com/locations/independence/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=independence",
      "poi_directions_map_url": "https://maps.google.com/?cid=9005618614391089194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "39.0291528",
      "poi_longitude": "-94.355281",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-795-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp5k7XFUcwYcRKihtfWpi-nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_9a388be8-4890-44d9-9609-f5c2ab5e2046",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Black Bear Diner Independence",
      "poi_type": "Restaurants",
      "poi_address": "4053 Little Blue Pkwy, Independence, MO 64057, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "People say this restaurant serves delicious biscuits and gravy, burgers, and pancakes. They also highlight the generous portions, reasonable prices, and friendly staff.\n\nOther reviews mention the food can be average.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-48e6-72da-9565-e9295f409966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-48e6-72da-9565-e9295f409966",
        "storage_key": "property/6767906449165632/019d7913-48e6-72da-9565-e9295f409966.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/independence/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1479390164462320323&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-independence",
      "poi_latitude": "39.0418355",
      "poi_longitude": "-94.3401149",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-559-3918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB74ygY0dwYcRw7r7NITZhxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_02c68fe7-1b0e-4d5e-9030-6dd1a433b84d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Thai Spice Independence",
      "poi_type": "Restaurants",
      "poi_address": "18931 E Valley View Pkwy D, Independence, MO 64055, USA",
      "poi_short_description": "Unassuming strip-mall kitchen offering Thai curries, noodle dishes & weekday lunch specials.",
      "poi_long_description": "People say this Thai restaurant serves delicious dishes, especially the honeymoon chicken and pineapple fried rice. They also highlight the flavorful and fresh food, and the good portion sizes.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-53cb-7538-a92d-18a151cbf6aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-53cb-7538-a92d-18a151cbf6aa",
        "storage_key": "property/6767906449165632/019d7913-53cb-7538-a92d-18a151cbf6aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thaispicekc.com/thai-spice-independence",
      "poi_directions_map_url": "https://maps.google.com/?cid=4601362077900421961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thai-spice-independence",
      "poi_latitude": "39.0337017",
      "poi_longitude": "-94.3554648",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-795-6789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7a81z_8cwYcRSTs1SG5S2z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_91d9333e-b0df-4767-9b5d-011a5c470d99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Old Chicago Pizza + Taproom",
      "poi_type": "Restaurants",
      "poi_address": "4661 S Cochise Ct, Independence, MO 64055, USA",
      "poi_short_description": "Family-friendly chain restaurant featuring Italian entrees along with a wide beer selection.",
      "poi_long_description": "People say this pizza restaurant serves delicious burgers, pizza, and spinach artichoke dip. They also highlight the decent prices, especially during happy hour, and the pub-style atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-5850-7451-a349-ba821a99af82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5850-7451-a349-ba821a99af82",
        "storage_key": "property/6767906449165632/019d7913-5850-7451-a349-ba821a99af82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://oldchicago.com/locations/us/mo/independence/4661-s-cochise-court/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3035627076268999972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-chicago-pizza-taproom",
      "poi_latitude": "39.03492300000001",
      "poi_longitude": "-94.363079",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-350-3559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUk1AwcdwYcRJEWSD762ICo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_da8610e8-bed3-4d50-9335-e656d29a19fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Salvatore's",
      "poi_type": "Restaurants",
      "poi_address": "12801 E US Hwy 40, Independence, MO 64055, USA",
      "poi_short_description": "Homey Italian trattoria with a menu heavy on pasta & veal, plus old-world wines.",
      "poi_long_description": "People say this Italian restaurant serves delicious dishes, including mussels in Diablo sauce, salads, and chicken Marsala. They highlight the fresh ingredients, generous portions, and the \"old school\" vibe. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-56c6-71fb-b6b5-d21de80d7758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-56c6-71fb-b6b5-d21de80d7758",
        "storage_key": "property/6767906449165632/019d7913-56c6-71fb-b6b5-d21de80d7758.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "http://salvatores-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12133301805490073109&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salvatore-s",
      "poi_latitude": "39.0384914",
      "poi_longitude": "-94.4292019",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-737-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeC-uvriwIcRFW7XBLUlYqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1553b379-b085-42d4-9ad9-2aadaeefa6af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Five Four Restaurant & Drafthouse- Independence",
      "poi_type": "Restaurants",
      "poi_address": "18700 E 38th Terrace S, Independence, MO 64057, USA",
      "poi_short_description": "Chain offering a broad American menu & drinks in a relaxed setting with kitschy, eclectic decor.",
      "poi_long_description": "Diners say this restaurant serves up delicious gringo dip, chicken fajita salad, burgers, and a wide selection of beers. They also highlight the friendly and attentive service, reasonable prices, and the lively, family-friendly atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-5fb6-71bc-9bd0-5d5d6fa10d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5fb6-71bc-9bd0-5d5d6fa10d88",
        "storage_key": "property/6767906449165632/019d7913-5fb6-71bc-9bd0-5d5d6fa10d88.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.54thstreetrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13786572463894815472&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "five-four-restaurant-drafthouse-independence",
      "poi_latitude": "39.0493017",
      "poi_longitude": "-94.3599057",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-795-7077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7bb2-77be-acb3-f68fddc1cb78",
        "storage_key": "property/6767906449165632/019cfb49-7bb2-77be-acb3-f68fddc1cb78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNarhwh4dwYcR8OKhjJy-U78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d9e2cc20-1c6d-4b08-987e-452c6622e217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "18710 East 39th St S, Independence, MO 64057, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop serves great coffee and delicious snacks. They also highlight the welcoming atmosphere and friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-673a-70dc-8464-1b890a68b378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-673a-70dc-8464-1b890a68b378",
        "storage_key": "property/6767906449165632/019d7913-673a-70dc-8464-1b890a68b378.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/11115/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436277706876210386&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "39.04846",
      "poi_longitude": "-94.36002",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-795-2708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-be9d-754f-a3e3-ea33709183b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-be9d-754f-a3e3-ea33709183b2",
        "storage_key": "property/6767906449165632/019d7913-be9d-754f-a3e3-ea33709183b2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7w1umuEcwYcR0kxLMJRk9II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_cdcf0bfc-3af2-42da-83e5-911ea1cdee2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Chaiyo Tea House",
      "poi_type": "Restaurants",
      "poi_address": "19321 E US Hwy 40 O, Independence, MO 64055, USA",
      "poi_short_description": "Family-run source for milk teas and other tea-based drinks, plus non-caffeinated options.",
      "poi_long_description": "People say this bubble tea store offers delicious milk tea, brown sugar milk tea, and taro milk tea with fresh, chewy boba. They highlight the great variety of options, the clean and welcoming atmosphere, and the quick service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-6ab8-74da-961b-32e14a7df9a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6ab8-74da-961b-32e14a7df9a3",
        "storage_key": "property/6767906449165632/019d7913-6ab8-74da-961b-32e14a7df9a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://linktr.ee/chaiyoteahouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=13412248838453489702&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chaiyo-tea-house",
      "poi_latitude": "39.0291033",
      "poi_longitude": "-94.3551474",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-673-0935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bq7jtIdwYcRJnAq50HhIbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_fd8930a1-f6a1-419a-a8ac-e0cbcf704e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "18001 Bass Pro Dr, Independence, MO 64055, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of fishing, hunting, and camping gear, as well as clothing and footwear. They highlight the fun, family-friendly atmosphere with live animals and a waterfall, and the helpful and friendly staff. They also like the good deals and sales.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-6aef-73ec-90f6-8a9e88bf242e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6aef-73ec-90f6-8a9e88bf242e",
        "storage_key": "property/6767906449165632/019d7913-6aef-73ec-90f6-8a9e88bf242e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/mo/independence/18001-bass-pro-dr.html?y_source=1_MzAxMTUyOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10682044519017351273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "39.0400967",
      "poi_longitude": "-94.370386",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-795-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXei1Pw4dwYcRaQjw5uQ-PpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_da148978-0c2a-498c-88d9-4c9cd55974b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Independence Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Independence, MO 64057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-7201-738b-bb8d-e566e6db49e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7201-738b-bb8d-e566e6db49e7",
        "storage_key": "property/6767906449165632/019d7913-7201-738b-bb8d-e566e6db49e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=349699110649972269&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "independence-center",
      "poi_latitude": "39.04662",
      "poi_longitude": "-94.359941",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZocUxwdwYcRLcaPBH1h2gQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_2b37672a-b595-4cdb-9e4a-2b5f7ed565f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "4300 Bass Pro Dr, Independence, MO 64055, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a great selection of craft supplies, decorations, and baking supplies. They also highlight the friendly and helpful staff, and the good deals and discounts.\n\nOther reviews mention the selection can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-76c6-7288-bb3c-02a84ff1be57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-76c6-7288-bb3c-02a84ff1be57",
        "storage_key": "property/6767906449165632/019d7913-76c6-7288-bb3c-02a84ff1be57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/180",
      "poi_directions_map_url": "https://maps.google.com/?cid=7048566479801414170&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "39.0419608",
      "poi_longitude": "-94.3730517",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-795-6609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFXLRzgwdwYcRGvJJVN6J0WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_b65b7b08-5f89-412c-9da6-361be5b643f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "19000 E Valley View Pkwy, Independence, MO 64055, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and convenient locations.\n\nOther reviews mention the customer service can be unhelpful and the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-60c5-75ba-b480-114ca06ab1de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb49-60c5-75ba-b480-114ca06ab1de",
        "storage_key": "property/6767906449165632/019cfb49-60c5-75ba-b480-114ca06ab1de.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MO-Independence/1098?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1098-_-na-_-0-_-0&y_source=1_MTE4NDE0NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18023124803024715029&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "39.0370132",
      "poi_longitude": "-94.3582354",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-795-7443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM6GDJgIdwYcRFf3RioQAH_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ae2f0b6f-edc8-4795-ba62-fca0148785bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "19040 E Valley View Pkwy #373c, Independence, MO 64055, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide selection of high-quality products, including fresh produce, bakery items, and bulk essentials. They highlight the great deals and value, and the clean, well-stocked, and organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-7baa-7085-8b1d-62a11c5b2783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7baa-7085-8b1d-62a11c5b2783",
        "storage_key": "property/6767906449165632/019d7913-7baa-7085-8b1d-62a11c5b2783.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/independence-MO-373.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14231665067127878441&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "39.0366091",
      "poi_longitude": "-94.357637",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-200-2003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmZlrFv4cwYcRKTN-2PkHgcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_03aeaea4-af50-4d02-9407-e36fa553fe0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Shopping & Retail",
      "poi_address": "19019 E 48th St, Independence, MO 64055, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "People say this grocery store offers great products. They highlight the friendly and helpful staff. They also like the knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-7dbf-767c-88cf-9558fe38db3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7dbf-767c-88cf-9558fe38db3c",
        "storage_key": "property/6767906449165632/019d7913-7dbf-767c-88cf-9558fe38db3c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/independence",
      "poi_directions_map_url": "https://maps.google.com/?cid=4605304875107426571&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "39.0305951",
      "poi_longitude": "-94.3575069",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-478-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b7f-778b-977f-1a1127d44097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b7f-778b-977f-1a1127d44097",
        "storage_key": "property/6767906449165632/019cfb49-7b7f-778b-977f-1a1127d44097.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXSnvqodwYcRCyEnS2JU6T8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_521ab8d5-da42-49dd-b113-3ce5af246906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "17810 East 39th St S, Independence, MO 64055, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products and the staff can be helpful.\n\nOther reviews mention the store can be messy and items can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-83c9-75c6-9e45-2cddd01a0c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-83c9-75c6-9e45-2cddd01a0c1f",
        "storage_key": "property/6767906449165632/019d7913-83c9-75c6-9e45-2cddd01a0c1f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/independence/1201",
      "poi_directions_map_url": "https://maps.google.com/?cid=14977356836133603890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.0511202",
      "poi_longitude": "-94.369521",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-373-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8Vg5ShYdwYcRMgoDZLBC2s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7d995f51-2982-48a7-bf92-ccc5f7c460bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 S Bolger Rd, Independence, MO 64055, USA",
      "poi_short_description": "Wide-ranging merchandise from electronics to clothing and housewares is offered by this department store chain.",
      "poi_long_description": "Some shoppers say this department store offers great prices on a wide variety of items and has friendly and helpful staff.\n\nOther reviews mention parking can be difficult and checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-83b3-739b-ac5e-7c52c1812af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-83b3-739b-ac5e-7c52c1812af3",
        "storage_key": "property/6767906449165632/019d7913-83b3-739b-ac5e-7c52c1812af3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1014-independence-mo/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17454639607451677816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.0458465",
      "poi_longitude": "-94.3671119",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-478-4090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDZiUBRodwYcRePSejD5WO_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9da8bb2c-c865-42a9-968a-8076b9d8c45a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "19110 East 39th St S, Independence, MO 64057, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of smart devices, TVs, and smart sound systems. They also highlight the helpful and knowledgeable staff, and the quick service.\n\nOther reviews mention the stock can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-87a4-766f-a21a-18f48fcd40c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-87a4-766f-a21a-18f48fcd40c6",
        "storage_key": "property/6767906449165632/019d7913-87a4-766f-a21a-18f48fcd40c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/mo/independence/19110-e-39th-st-s-36.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=18115791393368367978&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "39.050183",
      "poi_longitude": "-94.35494",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-795-9162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB-hfvx0dwYcRauPMako4aPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_bcd6c5ae-57a1-470e-b227-ea9f30e4573d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Merchant Square - Kansas City",
      "poi_type": "Shopping & Retail",
      "poi_address": "17730 East 39th St S, Independence, MO 64055, USA",
      "poi_short_description": "Vendors sell furniture, clothing, handmade items, and more at this expansive emporium with clean, spacious aisles.",
      "poi_long_description": "People say this antique furniture store offers a wide variety of antiques, boutiques, and unique treasures, with some booths featuring new or crafty items. They highlight the fun and interesting shopping experience, and the well-appointed booths with quality vendors. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-8d45-720c-b100-d940ce87ce20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8d45-720c-b100-d940ce87ce20",
        "storage_key": "property/6767906449165632/019d7913-8d45-720c-b100-d940ce87ce20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://merchantsquareantiques.com/kc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195048793090865762&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "merchant-square-kansas-city",
      "poi_latitude": "39.0507936",
      "poi_longitude": "-94.370619",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-663-1845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU1iLfxwdwYcRYrqcp6bONzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_37a444f0-7bfc-433b-87fb-c8dd770ae257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "World Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "19900 E Jackson Dr, Independence, MO 64057, USA",
      "poi_short_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_long_description": "People say this furniture store offers a wide variety of unique and exotic foods, drinks, and home goods from around the world. They highlight the interesting and fun cultural experience, and the great deals and discounts. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-94b5-77fd-84cf-89bfcc354133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-94b5-77fd-84cf-89bfcc354133",
        "storage_key": "property/6767906449165632/019d7913-94b5-77fd-84cf-89bfcc354133.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.worldmarket.com/mo/independence/19900-east-jackson-drive.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5909497037289115586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "world-market",
      "poi_latitude": "39.0423262",
      "poi_longitude": "-94.3456848",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-795-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ5VQdPAcwYcRwk_X3D7AAlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_7dcc7a9a-69eb-4ee4-86ab-6f208a25913d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Half Price Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "20000 E Jackson Dr, Independence, MO 64057, USA",
      "poi_short_description": "Family-owned chain that sells secondhand books as well as movies & music in various formats.",
      "poi_long_description": "People say this bookstore offers a wide variety of books, music, movies, board games, and gaming items, including signed and limited editions. They highlight the great prices and the opportunity to sell books. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-9397-714c-a036-c9a20b042919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9397-714c-a036-c9a20b042919",
        "storage_key": "property/6767906449165632/019d7913-9397-714c-a036-c9a20b042919.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hpb.com/store?storeid=HPB-078&showMap=true&horizontalView=true&isForm=true&y_source=1_MTExNTUyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14728536408685875446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "half-price-books",
      "poi_latitude": "39.0424527",
      "poi_longitude": "-94.3444316",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-795-7558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7ba1-73da-b8be-a504d2ac5272",
        "storage_key": "property/6767906449165632/019cfb49-7ba1-73da-b8be-a504d2ac5272.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwsaQfAcwYcR9hAhHdRFZsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_a92bdea7-6454-4e4f-b661-2807302341e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Waterfall Park",
      "poi_type": "Entertainment",
      "poi_address": "4501 S Bass Pro Dr, Independence, MO 64055, USA",
      "poi_short_description": "Peaceful park, featuring a playground and a pond with ducks.",
      "poi_long_description": "People say this park offers walking trails, a playground, picnic benches, and a lake with a dock. They highlight the beautiful scenery, peaceful atmosphere, and opportunities for fishing and watching wildlife. They also like the shade provided by trees and the availability of restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-987d-707f-8f67-0fd7c126eb91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-987d-707f-8f67-0fd7c126eb91",
        "storage_key": "property/6767906449165632/019d7913-987d-707f-8f67-0fd7c126eb91.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.independencemo.gov/government/city-departments/parks-recreation-and-tourism/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12957189118348035956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waterfall-park",
      "poi_latitude": "39.037969",
      "poi_longitude": "-94.3706025",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-325-7370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7e99-757a-9637-302899319d36",
        "storage_key": "property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCdUZH9MdwYcRdAexXtou0bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f94a247a-47ca-4639-a752-f2fcfd41a5b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Kansas City Zoo & Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "6800 Zoo Dr, Kansas City, MO 64132, USA",
      "poi_short_description": "Zoo in Swope Park with zookeepers offering animal interaction & informative chats.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including penguins, polar bears, and elephants, and features a beautiful aquarium with sharks and stingrays. They highlight the spacious, natural habitats, the fun rides like the train and tram, and the interactive experiences such as the petting zoo and animal encounters. They also like the friendly and helpful staff, and the clean, well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-9ebc-74d7-a8ec-da6cdd97a98d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9ebc-74d7-a8ec-da6cdd97a98d",
        "storage_key": "property/6767906449165632/019d7913-9ebc-74d7-a8ec-da6cdd97a98d.webp",
        "width": 680,
        "height": 473
      },
      "poi_business_url": "https://www.kansascityzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12992684715297648381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kansas-city-zoo-aquarium",
      "poi_latitude": "39.0072568",
      "poi_longitude": "-94.5293443",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 816-595-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaCDFcrlwIcR_a72DelJT7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_767667ad-1d42-452b-a924-053676c0f3e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "The National Museum of Toys and Miniatures",
      "poi_type": "Entertainment",
      "poi_address": "5235 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "Eclectic array of collectible toys, antique marbles & miniature reproductions of fine furnishings.",
      "poi_long_description": "People say this museum offers a captivating collection of vintage toys, dollhouses, and miniatures, with a wide variety and sophistication. They highlight the rich and varied displays, well-documented exhibits, and the fun look at different toys and miniatures throughout history. They also like the affordable admission price and the friendly, courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-a459-70ea-b4f1-4f2f5abc740c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a459-70ea-b4f1-4f2f5abc740c",
        "storage_key": "property/6767906449165632/019d7913-a459-70ea-b4f1-4f2f5abc740c.webp",
        "width": 1280,
        "height": 1014
      },
      "poi_business_url": "http://www.toyandminiaturemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3778476980352128529&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-national-museum-of-toys-and-miniatures",
      "poi_latitude": "39.0307741",
      "poi_longitude": "-94.5820813",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 54 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 816-235-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b88-7259-8f7a-5a785a44274e",
        "storage_key": "property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdcuZ5jvwIcRERbhXcvYbzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d696cc3f-670d-4304-8abd-3243cd88dbfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "George Owens Nature Park",
      "poi_type": "Entertainment",
      "poi_address": "1601 S Speck Rd, Independence, MO 64057, USA",
      "poi_short_description": "Charming year-round park featuring over 80-acres of wooded trails, lakes, rain gardens & wildlife.",
      "poi_long_description": "People say this nature preserve offers easy hiking trails, scenic views, and fishing spots. They highlight the quiet, clean, and enjoyable atmosphere, as well as the community education programs and seasonal exhibits. They also like the helpful staff and the fun nature center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-a8f3-7387-b439-b210977efd5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a8f3-7387-b439-b210977efd5c",
        "storage_key": "property/6767906449165632/019d7913-a8f3-7387-b439-b210977efd5c.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "http://www.ci.independence.mo.us/parksandrec/owens.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14663307917672924790&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "george-owens-nature-park",
      "poi_latitude": "39.085249",
      "poi_longitude": "-94.359769",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-325-7115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7e99-757a-9637-302899319d36",
        "storage_key": "property/6767906449165632/019cfb49-7e99-757a-9637-302899319d36.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbWrXdgCwYcRdkYRkdyIfss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_1a019428-23bb-475f-9a79-25d549e5ce98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Little Blue Trace Trail Access and Picnic Area",
      "poi_type": "Entertainment",
      "poi_address": "Little Blue Trace Trail, Independence, MO 64056, USA",
      "poi_short_description": "Well-maintained hiking and biking trail with picnic areas along a creek.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-ab4d-709a-88a0-b04490f62acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ab4d-709a-88a0-b04490f62acc",
        "storage_key": "property/6767906449165632/019d7913-ab4d-709a-88a0-b04490f62acc.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "http://www.makeyourdayhere.com/Facilities/Facility/Details/Little-Blue-Trace-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=6224165451186089954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "little-blue-trace-trail-access-and-picnic-area",
      "poi_latitude": "39.1029194",
      "poi_longitude": "-94.2963678",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF7BFFJMEwYcR4q80NYCtYFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_f40040e2-71a7-49dd-a7e1-9ea25a8e7a4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Lakewood Oaks Country Club",
      "poi_type": "Entertainment",
      "poi_address": "651 NE St Andrews Cir, Lee's Summit, MO 64064, USA",
      "poi_short_description": "Membership-only golf club set amidst oaks and lakes, providing an exclusive country club experience.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-b01e-72be-b8eb-b945bd24a4d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b01e-72be-b8eb-b945bd24a4d0",
        "storage_key": "property/6767906449165632/019d7913-b01e-72be-b8eb-b945bd24a4d0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lakewoodoakscc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16699019369712008180&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lakewood-oaks-country-club",
      "poi_latitude": "39.007557",
      "poi_longitude": "-94.3594435",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-373-2505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xvvPMkdwYcR9DsNPaTVvuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_8dc22a54-98d2-4d8f-ab8d-b4f408ae1633",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Hidden Valley Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "6500 NW Valley View Rd, Blue Springs, MO 64015, USA",
      "poi_short_description": "Park featuring baseball fields, a playground and concessions, along with soccer and softball fields.",
      "poi_long_description": "People say this sports complex offers nice playgrounds, beautiful ball fields, and turf infields. They also highlight the spacious metal bleachers, clean bathrooms, and convenient location near amenities.\n\nOther reviews mention the concessions can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-ae2e-7626-91a1-fbb0573b36cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ae2e-7626-91a1-fbb0573b36cb",
        "storage_key": "property/6767906449165632/019d7913-ae2e-7626-91a1-fbb0573b36cb.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.bluespringsgov.com/1388/Hidden-Valley-Sports-Complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=16034205754295327466&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hidden-valley-sports-complex",
      "poi_latitude": "39.0311221",
      "poi_longitude": "-94.3346794",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-228-0137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzyGPe2EcwYcR6hpMQC7xhN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_21d3e916-e7de-4cbe-a3e8-684eae5eed81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Lake Tapawingo",
      "poi_type": "Entertainment",
      "poi_address": "Lake Tapawingo, MO 64015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-b232-76c8-b21a-9cdbdf83d06d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b232-76c8-b21a-9cdbdf83d06d",
        "storage_key": "property/6767906449165632/019d7913-b232-76c8-b21a-9cdbdf83d06d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6660343120145543476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-tapawingo",
      "poi_latitude": "39.0195003",
      "poi_longitude": "-94.3147802",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b83-70f8-b9f2-5c7a3e4ab042",
        "storage_key": "property/6767906449165632/019cfb49-7b83-70f8-b9f2-5c7a3e4ab042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJW9KLokbwYcRNPF9nsdKblw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_c525ae77-33c0-47f2-9b81-3632a05c4018",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Missouri Town Living History Museum",
      "poi_type": "Entertainment",
      "poi_address": "8010 E Park Rd, Lee's Summit, MO 64064, USA",
      "poi_short_description": "This living history museum depicts19th-century farm life with original structures, exhibits & tours.",
      "poi_long_description": "People say this museum offers a glimpse into 19th-century life through preserved buildings, costumed interpreters, and interactive demonstrations. They highlight the beautiful setting, family-friendly atmosphere, and the opportunity to interact with animals. They also like the knowledgeable, enthusiastic, and kind staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d7913-b643-763a-9ee5-2005a611209a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b643-763a-9ee5-2005a611209a",
        "storage_key": "property/6767906449165632/019d7913-b643-763a-9ee5-2005a611209a.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "https://www.makeyourdayhere.com/Events-Attractions/Historic-Sites/Missouri-Town-Living-History-Museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=9107082874330255229&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "missouri-town-living-history-museum",
      "poi_latitude": "38.9726448",
      "poi_longitude": "-94.3204612",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 816-524-8770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-7b88-7259-8f7a-5a785a44274e",
        "storage_key": "property/6767906449165632/019cfb49-7b88-7259-8f7a-5a785a44274e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29F3P8sewYcRfY9_cJ_bYn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f6b160d5-51b2-41ef-8260-65051bfe2bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Los Cabos Mexican Grill and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "los-cabos-mexican-grill-and-cantina",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a79bdc5-e1d4-4206-afc3-97c671823d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "poi_name": "Gloria Jean’s Coffees",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "gloria-jean-s-coffees",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_226d7e75e7acdcd7217f5e3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3ffe902c10b6567a911bb554",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_79628e2ef513746b665340ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2211eccfb07c2ab03c8d6d5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0226a370e0a0eeae53622f30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_55d598565858046150738789",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_69e506be-9510-4ff3-b03c-48fee9775070",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "rating": "5.0",
      "name": "Jacquelyn Buford",
      "text": "I had such a wonderful experience touring the Adirondack Apartments & Townhomes, all thanks to Kylie. From the moment I arrived, she was warm, welcoming, and incredibly knowledgeable. She gave me a full tour of the property and a beautiful one-bedroom apartment, answering every question with patience and clarity.\n\nKylie made me feel completely at ease and genuinely excited about the possibility of living here. Her professionalism and friendly attitude turned what could have been a stressful search into a truly enjoyable visit. The property itself is stunning—well-maintained, peaceful, and full of charm—but it was Kylie who made the experience unforgettable.\n\nI’m really looking forward to becoming a tenant here, and I can’t thank Kylie enough for her help. If you’re considering a move, definitely ask for Kylie. She’s the best!",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_ff77b362-e8ff-4d3f-8126-e35015a6e858",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "rating": "5.0",
      "name": "Angie Honey C",
      "text": "I just moved in... Sophia was great and made the move-in process easy. It's quiet at night on weekends so far and they're animal friendly (I don't have any pets). It's clean and they take care of the property. They don't just let anyone in over here. I like the convenience of the location too! The pool is amazing and closed on Mondays for cleaning, but they go out every morning and clean it too. Pool's open 10am to 10pm. I love it so far",
      "date": "2025-09-01",
      "title": ""
    },
    {
      "id": "custom_edf983e7-d6fa-485e-8cb1-6063c5f55fdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "rating": "5.0",
      "name": "RANDY Shepard",
      "text": "Sophia and Kylee in the leasing office were professional, friendly and helpful! The complex is nice and quiet. The apartment was deep cleaned and ready to move in. Very happy with it all.",
      "date": "2025-10-01",
      "title": ""
    },
    {
      "id": "custom_a3374d98-7d5c-414d-8dc7-3b078b64c467",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "rating": "5.0",
      "name": "Hunter Hotop",
      "text": "I have lived here since June 2024, and it has been an amazing experience from the start. The 24/7 gym is always clean and ready for use, and the pool was well-maintained and respected throughout the summer. The staff is exceptional—from the initial tour to move-in, the leasing team was welcoming, communicative, and made the process enjoyable. The maintenance team is quick to respond and always friendly in passing. The dog park is spacious and a fantastic addition for pets to burn off energy. We’ve truly loved living here and will be renewing our lease next June!",
      "date": "2025-03-20",
      "title": ""
    },
    {
      "id": "custom_38f675f8-b5c7-479b-bf2d-498302cd54d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "rating": "5.0",
      "name": "Kim Wilcox",
      "text": "We went on a self-guided tour of the property and fell in love! The location, the beautiful apartments, and top-notch amenities all went beyond our expectations. Looking forward to hopefully living here soon!",
      "date": "2025-08-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_dfaec247-5813-4454-8aa9-071142bc7aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb4a-5446-7710-84d1-66ac50596fe1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island and dark cabinetry.",
        "public_id": "019cfb4a-5446-7710-84d1-66ac50596fe1",
        "storage_key": "property/6767906449165632/019cfb4a-5446-7710-84d1-66ac50596fe1.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Adirondack Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=69096c0bcae08b6164a6f820"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e47c-f020-75f3-b572-628a4cb109a4",
      "lead_source": "LANDING_PAGE",
      "name": "case-and-associates-the-adirondack",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632"
    },
    {
      "lead_collector_id": "019cf79d-3497-70b8-b362-7877d49447fd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-adirondack",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-apartments-with-pool-independence-mo",
      "search_query": "apartments with pool in Independence MO",
      "category": "Amenity",
      "h1_title": "Poolside Living in Independence, MO",
      "h2_subtitle": "Explore apartments with a pool in Independence, MO. Enjoy top-notch amenities at The Adirondack, including a refreshing swimming pool.",
      "page_copy": "Discover unparalleled apartment living with a pool at The Adirondack in Independence, MO. Nestled in the vibrant 39th East neighborhood, our community offers spacious one and two-bedroom units thoughtfully designed for modern comfort. Residents indulge in a variety of deluxe amenities, ensuring an outstanding living experience. Whether you're sunbathing by the sparkling pool, getting a workout in our well-equipped fitness center, or socializing in our serene, pet-friendly areas, life at The Adirondack is anything but ordinary.\n\nOur apartments with pool in Independence, MO, provide a peaceful retreat with the benefits of a gated community and around-the-clock access. Each apartment is fitted with convenient features like dishwashers, ceiling fans, and fireplaces, merging practicality with style. With easy access to local attractions and a welcoming community atmosphere, The Adirondack is perfect for anyone looking to elevate their lifestyle. Connect with us today to schedule a personal tour and see what makes our poolside living so special.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Independence, MO",
      "seo_description": "Discover apartments with a pool in Independence, MO at The Adirondack, featuring spacious floor plans and luxurious amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-fitness-center-apartments-39th-east-mo",
      "search_query": "fitness center apartments in 39th East MO",
      "category": "Amenity",
      "h1_title": "Fitness-Focused Apartments in 39th East",
      "h2_subtitle": "Find fitness center apartments in 39th East, MO. The Adirondack offers modern living with top-notch fitness facilities.",
      "page_copy": "Elevate your living experience at The Adirondack, the perfect choice for those seeking fitness center apartments in the heart of 39th East, MO. Our community boasts a fully-equipped fitness center that caters to all your workout needs, whether you're into cardio, strength training, or both. Nestled in a prime location of Independence, our one and two-bedroom apartments offer the perfect balance of style and functionality.\n\nBeyond the fitness amenities, residents of The Adirondack enjoy a wealth of features, including gated access for peace of mind and a sparkling pool for relaxation after a workout. Spacious floor plans come equipped with modern conveniences such as dishwashers, ceiling fans, and fireplaces, providing all the comforts of home. With pet-friendly areas and a welcoming community vibe, The Adirondack stands out as the premier choice for active individuals. Reach out today to learn more about our community and schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 39th East, MO",
      "seo_description": "Discover fitness center apartments in 39th East, MO at The Adirondack. Enjoy modern amenities and a fully-equipped fitness center. Schedule your visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-dog-park-apartments-independence-64055",
      "search_query": "dog park apartments in Independence 64055",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Independence",
      "h2_subtitle": "Explore dog park apartments in Independence, 64055. The Adirondack offers a tranquil, pet-friendly environment for modern living.",
      "page_copy": "Welcome to The Adirondack, where our dog park apartments in Independence, 64055, offer an ideal retreat for pet lovers. Blending comfortable living with pet-friendly amenities, our community provides one and two-bedroom apartments nestled in the charming 39th East neighborhood. Our serene areas are perfect for pet owners who want a friendly environment for their furry friends.\n\nThe Adirondack extends beyond its pet-friendly features, boasting modern amenities like a refreshing pool, a gated community with 24-hour access, and a fully-equipped fitness center. Your apartment will be outfitted with essential conveniences such as dishwashers, ceiling fans, and fireplaces, ensuring your comfort at every turn. With tranquil outdoor spaces and a vibrant community feel, The Adirondack is the ideal choice for both you and your pet. We invite you to schedule a tour and experience our welcoming community firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Independence 64055",
      "seo_description": "Discover dog park apartments in Independence, MO 64055 at The Adirondack. Enjoy pet-friendly living with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-granite-countertops-apartments-independence-mo",
      "search_query": "granite countertops apartments in Independence Missouri",
      "category": "Amenity",
      "h1_title": "Stylish Apartments in Independence, MO",
      "h2_subtitle": "Discover granite countertops apartments in Independence, Missouri. Enjoy high-end finishes at The Adirondack.",
      "page_copy": "At The Adirondack, we redefine upscale living with our granite countertops apartments in Independence, Missouri. Located in the desirable 39th East neighborhood, our community offers elegantly designed one and two-bedroom floor plans that feature exquisite granite countertops, adding a touch of luxury and sophistication to your home.\n\nBeyond high-end finishes, residents of The Adirondack enjoy access to a host of exceptional amenities. Our community includes a sparkling pool perfect for relaxing, a state-of-the-art fitness center, and gated access with 24-hour service. Each apartment is not only aesthetically pleasing but also functional, featuring essentials like dishwashers, ceiling fans, and cozy fireplaces. Whether you're indulging in the refined details or exploring the vibrant surrounding community, The Adirondack offers a luxurious living experience like no other. Schedule a tour today and see the elegance of our community firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apartments in Independence MO",
      "seo_description": "Explore granite countertops apartments in Independence, MO at The Adirondack. Experience luxury living with stylish finishes. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-washer-dryer-hookup-apartments-39th-east",
      "search_query": "washer dryer hookup apartments in 39th East",
      "category": "Amenity",
      "h1_title": "Convenient Living in 39th East Apartments",
      "h2_subtitle": "Explore washer dryer hookup apartments in 39th East at The Adirondack. Modern conveniences await in a vibrant community.",
      "page_copy": "Experience modern convenience with our washer dryer hookup apartments in the bustling neighborhood of 39th East. At The Adirondack, we offer one and two-bedroom apartments equipped with all the essentials required for comfortable living, including washer and dryer hookups, so chores are a breeze.\n\nOur community combines convenience with a host of luxury amenities: unwind by the pool, stay active in our fully-equipped fitness center, and benefit from the security of a gated living environment. Each unit is thoughtfully designed, featuring dishwashers, ceiling fans, and inviting fireplaces to make every day feel like a retreat. Located in Independence, MO, The Adirondack places you in the heart of a vibrant neighborhood with easy access to everything you need. Schedule a tour today and discover why our residences are the perfect place for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Apartments in 39th East",
      "seo_description": "Find washer dryer hookup apartments in 39th East at The Adirondack. Enjoy modern amenities in a vibrant community. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-one-bedroom-apartments-independence-mo",
      "search_query": "one bedroom apartments independence mo",
      "category": "Floorplan",
      "h1_title": "Chic One Bedroom Apartments in Independence",
      "h2_subtitle": "Explore our one bedroom apartments in Independence, MO. Discover The Adirondack, where style meets comfort.",
      "page_copy": "Welcome to The Adirondack, where our stylish one bedroom apartments in Independence, MO offer an inviting blend of modern design and cozy charm. Situated in the vibrant 39th East neighborhood, each apartment is crafted with you in mind, providing a perfect retreat after a busy day. From sleek interiors to thoughtful layouts, these living spaces offer both elegance and functionality.\n\nResidents of The Adirondack enjoy access to an array of top-notch amenities. Dive into relaxation at our refreshing pool, maintain an active lifestyle in our well-equipped fitness center, or unwind in our serene, pet-friendly areas. Our gated community also offers 24-hour access for peace of mind. With features like dishwashers, ceiling fans, and fireplaces, our one bedroom apartments provide a comfortable and convenient lifestyle. Come and see why The Adirondack is the ideal choice for your next home. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Independence MO",
      "seo_description": "Discover one bedroom apartments in Independence, MO at The Adirondack. Enjoy stylish living with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-two-bedroom-apartments-near-39th-east",
      "search_query": "two bedroom apartments near 39th east independence mo",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedrooms Near 39th East",
      "h2_subtitle": "Find two bedroom apartments near 39th East in Independence, MO. Experience comfort at The Adirondack.",
      "page_copy": "Discover spacious living at The Adirondack with our two bedroom apartments near 39th East in Independence, MO. Designed for both comfort and style, each apartment offers generous living spaces that cater to all your needs. Positioned in a vibrant neighborhood, our residences provide easy access to everything Independence has to offer.\n\nOur community ensures residents enjoy a lifestyle of convenience and luxury. Take advantage of on-site amenities such as a shimmering pool, state-of-the-art fitness center, and pet-friendly areas. The gated complex provides security and peace, with 24-hour access. Inside each apartment, you'll find conveniences like dishwashers, ceiling fans, and cozy fireplaces, making The Adirondack the perfect place to call home. Schedule a tour today and see what makes our two bedroom apartments stand out.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 39th East",
      "seo_description": "Explore two bedroom apartments near 39th East in Independence, MO at The Adirondack. Enjoy spacious living and modern amenities. Book your tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-apartments-near-mcc-blue-river",
      "search_query": "apartments near metropolitan community college blue river independence",
      "category": "School",
      "h1_title": "Convenient Living Near MCC Blue River",
      "h2_subtitle": "Discover apartments near Metropolitan Community College Blue River in Independence, offering modern comforts at The Adirondack.",
      "page_copy": "Located just a short drive from Metropolitan Community College Blue River, The Adirondack offers ideal apartment living in Independence, MO. Ideal for students and professionals alike, our modern apartments provide the perfect balance of convenience and comfort, making daily commutes a breeze.\n\nOur community offers a host of luxurious amenities, including a sparkling pool for relaxation, a comprehensive fitness center to support an active lifestyle, and pet-friendly areas perfect for your furry companions. Each apartment is thoughtfully equipped with ceiling fans, dishwashers, and fireplaces, creating a warm and inviting environment. The gated community ensures security and peace of mind with 24-hour access. Experience the best of Independence living at The Adirondack, where proximity to MCC Blue River and a thriving neighborhood enhance your living experience. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MCC Blue River Independence",
      "seo_description": "Find apartments near MCC Blue River in Independence at The Adirondack. Enjoy modern comforts and easy commutes. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-apartments-near-centerpoint-medical",
      "search_query": "apartments near centerpoint medical center independence mo",
      "category": "Hospital",
      "h1_title": "Comfortable Living Near Centerpoint Medical",
      "h2_subtitle": "Explore apartments near Centerpoint Medical Center in Independence, MO. Discover The Adirondack's ideal location and community features.",
      "page_copy": "The Adirondack offers the perfect home base for those seeking apartments near Centerpoint Medical Center in Independence, MO. Our location provides quick access to the medical center, making it ideal for healthcare professionals or anyone needing proximity to medical facilities. \n\nThe community at The Adirondack includes appealing amenities such as a refreshing swimming pool, a cutting-edge fitness center, and pet-friendly spaces, catering to varied lifestyles. Residents enjoy the peace of mind of a gated community with 24-hour access. Each apartment is equipped with conveniences like ceiling fans, dishwashers, and fireplaces, ensuring a comfortable living experience. Located in the thriving 39th East neighborhood, our apartments offer both a convenient location and an inviting community environment. Plan a visit today to see what makes The Adirondack the ideal choice near Centerpoint Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Centerpoint Medical Center Independence",
      "seo_description": "Discover The Adirondack apartments near Centerpoint Medical Center in Independence, MO. Enjoy a prime location and top amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-living-near-university-health-lakewood",
      "search_query": "living close to university health lakewood medical center 64055",
      "category": "Hospital",
      "h1_title": "Prime Living Near University Health Lakewood",
      "h2_subtitle": "Enjoy living close to University Health Lakewood Medical Center in 64055. Discover convenience and comfort at The Adirondack.",
      "page_copy": "Experience the best of Independence, MO at The Adirondack, where living close to University Health Lakewood Medical Center is both convenient and comfortable. Our community is ideal for healthcare professionals and families looking for close proximity to top medical facilities.\n\nResidents at The Adirondack enjoy a range of exceptional amenities, including a relaxing pool, modern fitness center, and designated pet-friendly areas. The gated community with 24-hour access provides a secure environment, while each apartment comes equipped with features like ceiling fans, dishwashers, and fireplaces. Situated in the bustling 64055 area, The Adirondack offers both a vibrant neighborhood and the comfort of a serene living environment. Visit us today to see why The Adirondack is the perfect home for those seeking easy access to University Health Lakewood Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to University Health Lakewood 64055",
      "seo_description": "Live near University Health Lakewood Medical Center 64055 at The Adirondack. Enjoy top amenities and a prime location. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-apartments-near-adair-park",
      "search_query": "apartments near Adair Park Independence",
      "category": "Park",
      "h1_title": "Ideal Apartments Near Adair Park",
      "h2_subtitle": "Explore The Adirondack's apartments near Adair Park in Independence. Discover convenience and comfort in every detail.",
      "page_copy": "Nestled conveniently near Adair Park in Independence, The Adirondack offers an exceptional living experience. Our location is perfect for those who love the outdoors and appreciate easy access to open spaces, making it a great choice for active individuals and families alike.\n\nThe Adirondack community features a host of amenities, including a refreshing pool, a state-of-the-art fitness center, and welcoming pet-friendly areas, making it the perfect match for healthy, active lifestyles. Gated with 24-hour access, our community ensures peace of mind and security. Inside each apartment, enjoy the comfort of ceiling fans, dishwashers, and a cozy fireplace, all designed to enhance your living experience. Situated in Independence's charming 39th East neighborhood, The Adirondack provides both an inviting community feel and proximity to Adair Park. Visit today and see why our apartments are the perfect choice near Adair Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Adair Park Independence",
      "seo_description": "Find your home at The Adirondack near Adair Park, Independence. Enjoy amenities like a pool, fitness center, and more. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-rental-homes-near-blue-springs-lake",
      "search_query": "rental homes close to Blue Springs Lake Campground Jackson County",
      "category": "Park",
      "h1_title": "Rental Homes by Blue Springs Lake Campground",
      "h2_subtitle": "Discover rental homes close to Blue Springs Lake Campground in Jackson County. The Adirondack offers unmatched convenience and comfort.",
      "page_copy": "For those looking to experience the best of nature while residing in Jackson County, The Adirondack provides ideal rental homes close to Blue Springs Lake Campground. With easy access to outdoor adventures and scenic beauty, our community is perfect for nature enthusiasts and families alike.\n\nAt The Adirondack, residents enjoy a variety of top-notch amenities, such as a refreshing pool, a fully-equipped fitness center, and serene pet-friendly areas—all designed to complement an active, outdoor lifestyle. The gated community ensures security with 24-hour access, while inside each home, you'll find conveniences like dishwashers, ceiling fans, and fireplaces for added comfort. Located in the vibrant area of Independence, MO, our homes offer an attractive balance of tranquil surroundings and modern living. Visit us and discover why The Adirondack is the perfect choice for those seeking proximity to Blue Springs Lake Campground.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Blue Springs Lake Campground",
      "seo_description": "Explore rental homes at The Adirondack near Blue Springs Lake Campground in Jackson County. Enjoy comfort and convenience today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165632",
      "source": "generator",
      "page_item_url": "the-adirondack-living-spaces-by-burrus-old-mill-park",
      "search_query": "living spaces by Burrus Old Mill Park 64055",
      "category": "Park",
      "h1_title": "Living Spaces Near Burrus Old Mill Park",
      "h2_subtitle": "Experience premium living spaces by Burrus Old Mill Park in 64055. Discover the perfect blend of location and luxury at The Adirondack.",
      "page_copy": "Situated just moments from Burrus Old Mill Park, The Adirondack presents splendid living spaces perfect for those seeking a harmonious blend of nature and modern convenience. Our community is ideally located for individuals and families who love outdoor activities and desire swift access to pristine local parks.\n\nThe Adirondack boasts an array of superior amenities, including a sparkling pool, a top-tier fitness center, and pet-friendly zones, catering to both active lifestyles and relaxation seekers. With a secure, gated environment offering 24-hour access, you will find peace of mind in your new home. Each apartment is thoughtfully equipped with ceiling fans, fireplaces, and dishwashers, ensuring everyday comfort and convenience. Set in the lively neighborhood of Independence, MO, these living spaces provide easy access to Burrus Old Mill Park, making The Adirondack a prime destination for your next home. Visit us and explore the community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb44b-90d7-71aa-93b3-be46a1bfb4e6",
        "storage_key": "property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Spaces by Burrus Old Mill Park",
      "seo_description": "Live close to Burrus Old Mill Park in 64055 at The Adirondack. Experience premium amenities and an ideal location. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5142"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-PYJ5WNJ4DC"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128850588"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/adirondack/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PLZQV66N"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165632/019d1bda-207e-7351-879b-f61016fa21ba.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47323490390"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "a4c157e1-ce50-4c20-94b7-1cbcb18ebfc9"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-254-2149"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "65bd4141749047df88448413"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkFIY0lWUm8zZUkyR2FBaTlndlJGNkE9PSIsInZhbHVlIjoiejFLWHNTY3BXcGFUVzI5ZWZVSFdKUT09IiwibWFjIjoiNjYxZGFhMmYyZjc5M2RjNTRmNzgwZTEwODU3MzhjNzg4YjMzNWM5ODE1NWQ0M2VkYTAzMTEzNjA4MjE1OWIzOCJ9"
    }
  ],
  "custom_qb_id": "5142",
  "custom_ga4_id": "G-PYJ5WNJ4DC",
  "custom_repli_id": "18128850588",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/adirondack/register/",
  "custom_google_gtm_id": "GTM-PLZQV66N",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165632/019d1bda-207e-7351-879b-f61016fa21ba.pdf",
  "custom_hubspot_company_id": "47323490390",
  "custom_rentgrata_property_id": "a4c157e1-ce50-4c20-94b7-1cbcb18ebfc9",
  "custom_ppc_tracking_phone_number": "866-254-2149",
  "custom_residentboost_apartment_id": "65bd4141749047df88448413",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkFIY0lWUm8zZUkyR2FBaTlndlJGNkE9PSIsInZhbHVlIjoiejFLWHNTY3BXcGFUVzI5ZWZVSFdKUT09IiwibWFjIjoiNjYxZGFhMmYyZjc5M2RjNTRmNzgwZTEwODU3MzhjNzg4YjMzNWM5ODE1NWQ0M2VkYTAzMTEzNjA4MjE1OWIzOCJ9"
};

export const generatedAt = '2026-08-27T21:36:11.680Z';
